(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[405],{

/***/ 29930:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(53219);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





var CashIcon = function CashIcon(props) {
  return (
    /*#__PURE__*/
    // eslint-disable-next-line react/jsx-props-no-spreading
    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, _objectSpread(_objectSpread({}, props), {}, {
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("path", {
        d: "M21.8055 10.0415H21V10H12V14H17.6515C16.827 16.3285 14.6115 18 12 18C8.6865 18 6 15.3135 6 12C6 8.6865 8.6865 6 12 6C13.5295 6 14.921 6.577 15.9805 7.5195L18.809 4.691C17.023 3.0265 14.634 2 12 2C6.4775 2 2 6.4775 2 12C2 17.5225 6.4775 22 12 22C17.5225 22 22 17.5225 22 12C22 11.3295 21.931 10.675 21.8055 10.0415Z",
        fill: "#FFC107"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("path", {
        d: "M3.15308 7.3455L6.43858 9.755C7.32758 7.554 9.48058 6 12.0001 6C13.5296 6 14.9211 6.577 15.9806 7.5195L18.8091 4.691C17.0231 3.0265 14.6341 2 12.0001 2C8.15908 2 4.82808 4.1685 3.15308 7.3455Z",
        fill: "#FF3D00"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("path", {
        d: "M11.9999 22C14.5829 22 16.9299 21.0115 18.7044 19.404L15.6094 16.785C14.5717 17.5742 13.3036 18.001 11.9999 18C9.39891 18 7.19041 16.3415 6.35841 14.027L3.09741 16.5395C4.75241 19.778 8.11341 22 11.9999 22Z",
        fill: "#4CAF50"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("path", {
        d: "M21.8055 10.0415H21V10H12V14H17.6515C17.2571 15.1082 16.5467 16.0766 15.608 16.7855L15.6095 16.7845L18.7045 19.4035C18.4855 19.6025 22 17 22 12C22 11.3295 21.931 10.675 21.8055 10.0415Z",
        fill: "#1976D2"
      })]
    }))
  );
};

/* harmony default export */ __webpack_exports__["Z"] = (CashIcon);

/***/ }),

/***/ 43912:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(53219);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }






var WhiteLogoAvatar = function WhiteLogoAvatar(props) {
  return (
    /*#__PURE__*/
    // eslint-disable-next-line react/jsx-props-no-spreading
    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, _objectSpread(_objectSpread({}, props), {}, {
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
        d: "M32.6265 34.0556C34.5382 34.0556 36.0878 32.5463 36.0878 30.6846C36.0878 28.8228 34.5382 27.3135 32.6265 27.3135C30.7148 27.3135 29.1651 28.8228 29.1651 30.6846C29.1651 32.5463 30.7148 34.0556 32.6265 34.0556Z",
        fill: "white"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
        d: "M22.7959 34.0556C24.7075 34.0556 26.2572 32.5463 26.2572 30.6846C26.2572 28.8228 24.7075 27.3135 22.7959 27.3135C20.8842 27.3135 19.3345 28.8228 19.3345 30.6846C19.3345 32.5463 20.8842 34.0556 22.7959 34.0556Z",
        fill: "white"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
        d: "M45.9398 6.67487C45.6622 6.04226 45.1426 5.55697 44.4806 5.30566C44.1709 5.1878 43.847 5.12887 43.5142 5.12887H27.2894C25.8372 5.12887 24.6538 6.26584 24.6538 7.66451C24.6538 9.06145 25.8355 10.2001 27.2894 10.2001H39.6008L37.6308 14.8693C36.0843 18.5697 32.3471 20.9614 28.1133 20.9614C23.8636 20.9493 20.0018 18.4171 18.5052 14.6665L13.5935 2.23967C13.2073 1.26216 12.2178 0.605286 11.1304 0.605286H2.95131C1.49914 0.605286 0.315674 1.74224 0.315674 3.14092C0.315674 4.53959 1.49736 5.67656 2.95131 5.67656H9.31345L13.5792 16.469C15.8411 22.1903 21.6801 26.0362 28.1098 26.0362C29.9624 26.0362 31.79 25.7207 33.5412 25.0985C37.6219 23.6496 40.8928 20.6148 42.5123 16.7724L45.9523 8.61949C46.2192 7.98861 46.2139 7.29881 45.9398 6.67487Z",
        fill: "white"
      })]
    }))
  );
};

/* harmony default export */ __webpack_exports__["Z"] = (WhiteLogoAvatar);

/***/ }),

/***/ 88156:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_LineItem; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@mui/styles/makeStyles/makeStyles.js + 27 modules
var makeStyles = __webpack_require__(59874);
// EXTERNAL MODULE: ./node_modules/@mui/material/Box/Box.js
var Box = __webpack_require__(99226);
// EXTERNAL MODULE: ./node_modules/@mui/material/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(15861);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/containers/LoyaltyContainer/components/LineItem/LineItem.tsx





var useStyles = (0,makeStyles/* default */.Z)(function (theme) {
  return {
    root: {
      display: 'flex',
      justifyContent: 'space-between',
      color: '#636965',
      '& + &': {
        marginTop: '0.375rem'
      }
    },
    legend: {
      fontWeight: 500,
      fontSize: '0.875rem',
      lineHeight: '150%'
    },
    value: {
      fontWeight: 600,
      fontSize: '0.875rem',
      lineHeight: '21px'
    }
  };
});

var LineItem = function LineItem(_ref) {
  var legend = _ref.legend,
      value = _ref.value;
  var classes = useStyles();

  var resolveValue = function resolveValue(valueToResolve) {
    if (!valueToResolve) {
      return 'Ilimitado';
    }

    var valueIsBiggerThenOne = valueToResolve > 1;
    return "".concat(valueToResolve, " ").concat(valueIsBiggerThenOne ? 'dias' : 'dia');
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(Box/* default */.Z, {
    className: classes.root,
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Typography/* default */.Z, {
      "data-testid": "legend",
      className: classes.legend,
      children: legend
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Typography/* default */.Z, {
      "data-testid": "value",
      className: classes.value,
      variant: "h3",
      children: resolveValue(value)
    })]
  });
};

/* harmony default export */ var LineItem_LineItem = (LineItem);
;// CONCATENATED MODULE: ./src/containers/LoyaltyContainer/components/LineItem/index.ts

/* harmony default export */ var components_LineItem = (LineItem_LineItem);

/***/ }),

/***/ 84698:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_LoyaltyInformation; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@mui/styles/makeStyles/makeStyles.js + 27 modules
var makeStyles = __webpack_require__(59874);
// EXTERNAL MODULE: ./node_modules/@mui/system/esm/colorManipulator.js
var colorManipulator = __webpack_require__(41796);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/useTheme.js
var useTheme = __webpack_require__(2734);
// EXTERNAL MODULE: ./node_modules/@mui/material/useMediaQuery/useMediaQuery.js
var useMediaQuery = __webpack_require__(98396);
// EXTERNAL MODULE: ./node_modules/@mui/material/Box/Box.js
var Box = __webpack_require__(99226);
// EXTERNAL MODULE: ./node_modules/@mui/material/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(15861);
// EXTERNAL MODULE: ./src/helpers/utils/array.ts
var array = __webpack_require__(74526);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/containers/LoyaltyContainer/components/LoyaltyCard/components/OrderIndicatorBar/OrderIndicatorBar.tsx





var useStyles = (0,makeStyles/* default */.Z)(function (theme) {
  return {
    root: {
      display: 'flex',
      gap: 8
    },
    bar: {
      height: 5,
      borderRadius: 5,
      flex: 1
    }
  };
});

var OrderIndicatorBar = function OrderIndicatorBar(_ref) {
  var totalBars = _ref.totalBars,
      currentBar = _ref.currentBar;
  var classes = useStyles();
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Box/* default */.Z, {
    className: classes.root,
    children: (0,array/* ArrayOfNItens */.T)(totalBars).map(function (index) {
      return /*#__PURE__*/(0,jsx_runtime.jsx)(Box/* default */.Z, {
        "data-testid": "order-indicator-bar-bar",
        className: classes.bar,
        style: {
          backgroundColor: index + 1 <= currentBar ? '#FFBE5C' : '#CACECC'
        }
      }, index);
    })
  });
};

/* harmony default export */ var OrderIndicatorBar_OrderIndicatorBar = (OrderIndicatorBar);
;// CONCATENATED MODULE: ./src/containers/LoyaltyContainer/components/LoyaltyCard/components/OrderIndicatorBar/index.ts

/* harmony default export */ var components_OrderIndicatorBar = (OrderIndicatorBar_OrderIndicatorBar);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/esm/Stars.js
var Stars = __webpack_require__(45727);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/esm/KeyboardArrowRight.js
var KeyboardArrowRight = __webpack_require__(26602);
// EXTERNAL MODULE: ./node_modules/@mui/material/Skeleton/Skeleton.js + 2 modules
var Skeleton = __webpack_require__(88078);
// EXTERNAL MODULE: ./node_modules/@mui/material/IconButton/IconButton.js + 1 modules
var IconButton = __webpack_require__(93946);
;// CONCATENATED MODULE: ./src/containers/LoyaltyContainer/components/LoyaltyCard/components/LoyaltyInformation/components/LoyaltyInformationSkeleton/LoyaltyInformationSkeleton.tsx







var LoyaltyInformationSkeleton_useStyles = (0,makeStyles/* default */.Z)(function (theme) {
  return {
    starIcon: {
      fontSize: 24,
      color: '#FFBE5C',
      backgroundColor: (0,colorManipulator/* alpha */.Fq)('#FFBE5C', 0.1),
      padding: '0.5rem',
      borderRadius: '0.25rem',
      boxSizing: 'content-box',
      marginRight: '0.75rem'
    }
  };
});

var LoyaltyInformationSkeleton = function LoyaltyInformationSkeleton(_ref) {
  var onClick = _ref.onClick,
      singleComponentVariant = _ref.singleComponentVariant;
  var classes = LoyaltyInformationSkeleton_useStyles();

  var getRandomArbitrary = function getRandomArbitrary(min, max) {
    return Math.random() * (max - min) + min;
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(Box/* default */.Z, {
    "data-testid": "loyalty-information-skeleton-container",
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(Box/* default */.Z, {
      style: {
        marginBottom: '1rem',
        display: 'flex',
        alignItems: 'center'
      },
      children: [singleComponentVariant && /*#__PURE__*/(0,jsx_runtime.jsx)(Stars/* default */.Z, {
        className: classes.starIcon
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Box/* default */.Z, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
          variant: "text",
          animation: "wave",
          width: getRandomArbitrary(200, 250),
          height: 20
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
          variant: "text",
          animation: "wave",
          width: getRandomArbitrary(150, 200),
          height: 20
        })]
      }), onClick && /*#__PURE__*/(0,jsx_runtime.jsx)(IconButton/* default */.Z, {
        size: "small",
        disabled: true,
        style: {
          marginLeft: '0.75rem'
        },
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(KeyboardArrowRight/* default */.Z, {})
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Box/* default */.Z, {
      display: "flex",
      gap: "8px",
      children: (0,array/* ArrayOfNItens */.T)(Math.round(getRandomArbitrary(2, 5))).map(function (index) {
        return /*#__PURE__*/(0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
          variant: "text",
          animation: "wave",
          height: 10,
          style: {
            flex: 1
          }
        }, index);
      })
    })]
  });
};

/* harmony default export */ var LoyaltyInformationSkeleton_LoyaltyInformationSkeleton = (LoyaltyInformationSkeleton);
;// CONCATENATED MODULE: ./src/containers/LoyaltyContainer/components/LoyaltyCard/components/LoyaltyInformation/components/LoyaltyInformationSkeleton/index.ts

/* harmony default export */ var components_LoyaltyInformationSkeleton = (LoyaltyInformationSkeleton_LoyaltyInformationSkeleton);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/helpers/utils/index.ts + 28 modules
var utils = __webpack_require__(58679);
;// CONCATENATED MODULE: ./src/containers/LoyaltyContainer/components/LoyaltyCard/components/LoyaltyInformation/LoyaltyInformation.tsx










var LoyaltyInformation_useStyles = (0,makeStyles/* default */.Z)(function (theme) {
  return {
    orderQuantity: {
      fontWeight: 600,
      fontSize: '0.875rem',
      lineHeight: '21px'
    },
    orderMinValue: {
      fontWeight: 500,
      fontSize: '0.75rem',
      lineHeight: '21px',
      color: '#7C837F'
    },
    starIcon: {
      fontSize: 24,
      color: '#FFBE5C',
      backgroundColor: (0,colorManipulator/* alpha */.Fq)('#FFBE5C', 0.1),
      padding: '0.5rem',
      borderRadius: '0.25rem',
      boxSizing: 'content-box',
      marginRight: '0.75rem'
    }
  };
});

var LoyaltyInformation = function LoyaltyInformation(_ref) {
  var data = _ref.data,
      currentPoints = _ref.currentPoints,
      singleComponentVariant = _ref.singleComponentVariant,
      onClick = _ref.onClick,
      isLoading = _ref.isLoading;
  var classes = LoyaltyInformation_useStyles();
  var theme = (0,useTheme/* default */.Z)();
  var isMobile = (0,useMediaQuery/* default */.Z)(theme.breakpoints.down('md'));

  var _useRouter = (0,router.useRouter)(),
      push = _useRouter.push;

  var handleClick = function handleClick() {
    if (isMobile) {
      push('/loyalty-info');
      return;
    }

    if (onClick) {
      onClick();
    }
  };

  if (isLoading) {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(components_LoyaltyInformationSkeleton, {
      singleComponentVariant: singleComponentVariant,
      onClick: Boolean(onClick)
    });
  }

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(Box/* default */.Z, {
    "data-testid": "loyalty-information-container",
    style: {
      cursor: 'pointer'
    },
    role: "button",
    onClick: handleClick,
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(Box/* default */.Z, {
      style: {
        marginBottom: '1rem',
        display: 'flex',
        alignItems: 'center'
      },
      children: [singleComponentVariant && /*#__PURE__*/(0,jsx_runtime.jsx)(Stars/* default */.Z, {
        className: classes.starIcon,
        "data-testid": "loyalty-information-star-icon"
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Box/* default */.Z, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(Typography/* default */.Z, {
          style: {
            color: '#191A19'
          },
          variant: "h2",
          className: classes.orderQuantity,
          children: ["Pe\xE7a ", data.orderQuantity, " vezes e ganhe", ' ', (0,utils/* toCurrencyValue */.y6)(data.couponDiscountValue)]
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Typography/* default */.Z, {
          style: {
            color: '#7C837F'
          },
          variant: "h4",
          className: classes.orderMinValue,
          children: ["Apenas pedidos acima de ", (0,utils/* toCurrencyValue */.y6)(data.orderMinValue)]
        })]
      }), onClick && /*#__PURE__*/(0,jsx_runtime.jsx)(KeyboardArrowRight/* default */.Z, {
        style: {
          marginLeft: '0.75rem'
        }
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(components_OrderIndicatorBar, {
      currentBar: currentPoints !== null && currentPoints !== void 0 ? currentPoints : 0,
      totalBars: data.orderQuantity
    })]
  });
};

/* harmony default export */ var LoyaltyInformation_LoyaltyInformation = (LoyaltyInformation);
;// CONCATENATED MODULE: ./src/containers/LoyaltyContainer/components/LoyaltyCard/components/LoyaltyInformation/index.ts

/* harmony default export */ var components_LoyaltyInformation = (LoyaltyInformation_LoyaltyInformation);

/***/ }),

/***/ 94746:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_LoyaltyInfoContent; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@mui/styles/makeStyles/makeStyles.js + 27 modules
var makeStyles = __webpack_require__(59874);
// EXTERNAL MODULE: ./node_modules/@mui/material/Box/Box.js
var Box = __webpack_require__(99226);
// EXTERNAL MODULE: ./node_modules/@mui/material/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(15861);
// EXTERNAL MODULE: ./node_modules/@mui/material/Card/Card.js + 1 modules
var Card = __webpack_require__(66242);
// EXTERNAL MODULE: ./src/containers/LoyaltyContainer/components/LineItem/index.ts + 1 modules
var LineItem = __webpack_require__(88156);
// EXTERNAL MODULE: ./src/helpers/utils/index.ts + 28 modules
var utils = __webpack_require__(58679);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/containers/LoyaltyContainer/components/LoyaltyInfoDialog/components/LoyaltyInfoContent/LoyaltyInfoContent.tsx







var useStyles = (0,makeStyles/* default */.Z)(function (theme) {
  return {
    root: {
      maxWidth: '37.5rem',
      margin: '0 auto'
    },
    subtitle: {
      fontWeight: 500,
      fontSize: '1rem',
      lineHeight: '150%',
      color: '#636965'
    },
    card: {
      padding: '1rem',
      margin: '1rem 0 1.5rem',
      display: 'flex',
      flexDirection: 'column',
      gap: 6
    },
    rulesTitle: {
      fontWeight: 600,
      fontSize: '1rem',
      lineHeight: '24px',
      color: '#191A19',
      marginBottom: '0.75rem'
    },
    ruleContainer: {
      paddingLeft: '0.5rem',
      display: 'flex',
      flexDirection: 'column'
    },
    ruleItem: {
      color: '#636965',
      fontWeight: 500,
      fontSize: '0.875rem',
      lineHeight: '150%',
      '& + &': {
        marginTop: '1.5rem'
      }
    }
  };
});
var rules = [{
  text: 'O cupom estará disponível para ser usado na próxima compra após conclusão do Programa, podendo ter data de validade ou não;'
}, {
  text: 'O cupom não é cumulativo com outros cupons;'
}, {
  text: 'Para poder participar do Programa é necessário estar logado no momento do checkout;'
}, {
  text: 'Para utilizar o cupom, é necessário estar logado;'
}, {
  text: 'Será contabilizado apenas pedidos válidos e finalizados para o programa;'
}, {
  text: 'Cada restaurante estipula uma data para completar o Programa, caso não seja cumprida o Programa reiniciará;'
}];

var LoyaltyInfoContent = function LoyaltyInfoContent(_ref) {
  var data = _ref.data;
  var classes = useStyles();
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(Box/* default */.Z, {
    className: classes.root,
    "data-testid": "loyalty-info-content",
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(Typography/* default */.Z, {
      className: classes.subtitle,
      children: ["A cada ", data.orderQuantity, " pedidos de", ' ', (0,utils/* toCurrencyValue */.y6)(data.orderMinValue), ", ganhe um cupom de", ' ', (0,utils/* toCurrencyValue */.y6)(data.couponDiscountValue)]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Card/* default */.Z, {
      variant: "outlined",
      className: classes.card,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(LineItem/* default */.Z, {
        legend: "Prazo para completar",
        value: data.daysToCompleteProgram
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(LineItem/* default */.Z, {
        legend: "Validade do cupom",
        value: data.couponDeadLineInDays
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Typography/* default */.Z, {
      className: classes.rulesTitle,
      children: "Regras:"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Box/* default */.Z, {
      className: classes.ruleContainer,
      children: rules.map(function (rule) {
        return /*#__PURE__*/(0,jsx_runtime.jsx)(Typography/* default */.Z, {
          className: classes.ruleItem,
          component: 'li',
          children: rule.text
        }, rule.text);
      })
    })]
  });
};

/* harmony default export */ var LoyaltyInfoContent_LoyaltyInfoContent = (LoyaltyInfoContent);
;// CONCATENATED MODULE: ./src/containers/LoyaltyContainer/components/LoyaltyInfoDialog/components/LoyaltyInfoContent/index.ts

/* harmony default export */ var components_LoyaltyInfoContent = (LoyaltyInfoContent_LoyaltyInfoContent);

/***/ }),

/***/ 31331:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_LoyaltyInfoDialog; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/@mui/material/Dialog/Dialog.js + 1 modules
var Dialog = __webpack_require__(50657);
// EXTERNAL MODULE: ./node_modules/@mui/material/DialogContent/DialogContent.js + 1 modules
var DialogContent = __webpack_require__(6514);
// EXTERNAL MODULE: ./node_modules/@mui/material/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(15861);
// EXTERNAL MODULE: ./node_modules/@mui/material/DialogActions/DialogActions.js + 1 modules
var DialogActions = __webpack_require__(31425);
// EXTERNAL MODULE: ./node_modules/@mui/material/Button/Button.js + 1 modules
var Button = __webpack_require__(11057);
// EXTERNAL MODULE: ./node_modules/@mui/styles/makeStyles/makeStyles.js + 27 modules
var makeStyles = __webpack_require__(59874);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/containers/LoyaltyContainer/components/LoyaltyInfoDialog/components/LoyaltyInfoContent/index.ts + 1 modules
var LoyaltyInfoContent = __webpack_require__(94746);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/containers/LoyaltyContainer/components/LoyaltyInfoDialog/LoyaltyInfoDialog.tsx







var useStyles = (0,makeStyles/* default */.Z)(function (theme) {
  return {
    paper: (0,defineProperty/* default */.Z)({
      width: '100%',
      maxWidth: 592
    }, theme.breakpoints.down('sm'), {
      margin: 0,
      height: '100%',
      maxHeight: '100%'
    }),
    dialogTitle: {
      padding: '1.25rem 1rem',
      borderBottom: '1px solid #CACECC'
    },
    dialogContent: (0,defineProperty/* default */.Z)({
      padding: '1.5rem'
    }, theme.breakpoints.down('sm'), {
      padding: '0 1rem',
      marginTop: '1rem'
    }),
    dialogActions: (0,defineProperty/* default */.Z)({
      padding: '0.5rem 1.5rem 1.5rem'
    }, theme.breakpoints.down('sm'), {
      padding: '0.5rem 1rem',
      borderTop: '1px solid #CACECC'
    }),
    title: (0,defineProperty/* default */.Z)({
      fontWeight: 700,
      fontSize: '1.125rem',
      lineHeight: '130%',
      color: '#121212',
      marginBottom: 8
    }, theme.breakpoints.down('sm'), {
      marginBottom: 0
    })
  };
});

var LoyaltyInfoDialog = function LoyaltyInfoDialog(_ref) {
  var open = _ref.open,
      onClose = _ref.onClose,
      data = _ref.data;
  var classes = useStyles();
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(Dialog/* default */.Z, {
    open: open,
    onBackdropClick: onClose,
    onClose: onClose,
    classes: {
      paper: classes.paper
    },
    "data-testid": "loyalty-info-dialog",
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(DialogContent/* default */.Z, {
      className: classes.dialogContent,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Typography/* default */.Z, {
        className: classes.title,
        children: "Programa de Fidelidade"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(LoyaltyInfoContent/* default */.Z, {
        data: data
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(DialogActions/* default */.Z, {
      className: classes.dialogActions,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(Button/* default */.Z, {
        "data-testid": "close-button",
        style: {
          height: 48
        },
        color: "primary",
        onClick: onClose,
        fullWidth: true,
        variant: "contained",
        disableElevation: true,
        children: "entendi"
      })
    })]
  });
};

/* harmony default export */ var LoyaltyInfoDialog_LoyaltyInfoDialog = (LoyaltyInfoDialog);
;// CONCATENATED MODULE: ./src/containers/LoyaltyContainer/components/LoyaltyInfoDialog/index.ts

/* harmony default export */ var components_LoyaltyInfoDialog = (LoyaltyInfoDialog_LoyaltyInfoDialog);

/***/ }),

/***/ 81467:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "I": function() { return /* binding */ auth; }
});

// EXTERNAL MODULE: ./node_modules/firebase/auth/dist/index.esm.js + 1 modules
var index_esm = __webpack_require__(17702);
// EXTERNAL MODULE: ./node_modules/firebase/app/dist/index.esm.js
var dist_index_esm = __webpack_require__(15503);
;// CONCATENATED MODULE: ./src/firebase/config.ts

var firebaseConfig = {
  apiKey: 'AIzaSyA6GFq8vExrStDjzG97XDwUAJAqU3R1bog',
  authDomain: 'auth.compraqui.app',
  databaseURL: 'https://lets-eat-prod-f882d.firebaseio.com',
  projectId: 'lets-eat-prod-f882d',
  storageBucket: 'lets-eat-prod-f882d.appspot.com',
  messagingSenderId: '151496253757',
  appId: '1:151496253757:web:cdd91b2a10bdef8e436554',
  measurementId: 'G-D3K17LSD7G'
};
var app = (0,dist_index_esm/* initializeApp */.ZF)(firebaseConfig);

;// CONCATENATED MODULE: ./src/firebase/auth/index.ts


var auth = (0,index_esm/* getAuth */.v0)(app);


/***/ }),

/***/ 5881:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "q": function() { return /* binding */ googleAuthProvider; }
/* harmony export */ });
/* harmony import */ var firebase_auth__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(17702);

var googleAuthProvider = new firebase_auth__WEBPACK_IMPORTED_MODULE_0__/* .GoogleAuthProvider */ .hJ();


/***/ }),

/***/ 74526:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "T": function() { return /* binding */ ArrayOfNItens; }
/* harmony export */ });
var ArrayOfNItens = function ArrayOfNItens(n) {
  return Array.from(Array(n).keys());
};

/***/ }),

/***/ 73968:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ pages; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(50029);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(87794);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/useTheme.js
var useTheme = __webpack_require__(2734);
// EXTERNAL MODULE: ./node_modules/@mui/material/useMediaQuery/useMediaQuery.js
var useMediaQuery = __webpack_require__(98396);
// EXTERNAL MODULE: ./node_modules/@mui/material/Box/Box.js
var Box = __webpack_require__(99226);
// EXTERNAL MODULE: ./node_modules/@mui/material/Collapse/Collapse.js + 1 modules
var Collapse = __webpack_require__(57922);
// EXTERNAL MODULE: ./node_modules/@mui/material/Hidden/Hidden.js + 4 modules
var Hidden = __webpack_require__(50456);
// EXTERNAL MODULE: ./node_modules/@mui/styles/makeStyles/makeStyles.js + 27 modules
var makeStyles = __webpack_require__(59874);
// EXTERNAL MODULE: ./node_modules/@reduxjs/toolkit/dist/redux-toolkit.esm.js + 2 modules
var redux_toolkit_esm = __webpack_require__(77236);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/query-string/index.js
var query_string = __webpack_require__(17563);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 18 modules
var es = __webpack_require__(25617);
// EXTERNAL MODULE: ./node_modules/react-toastify/dist/react-toastify.esm.js
var react_toastify_esm = __webpack_require__(72132);
// EXTERNAL MODULE: ./src/redux/reducers/discountCode/actions.ts
var actions = __webpack_require__(81368);
// EXTERNAL MODULE: ./src/redux/reducers/discountCode/reducer.ts
var reducer = __webpack_require__(27646);
// EXTERNAL MODULE: ./src/redux/reducers/establishment/reducer.ts
var establishment_reducer = __webpack_require__(45714);
// EXTERNAL MODULE: ./src/redux/reducers/order/reducer.ts
var order_reducer = __webpack_require__(74209);
// EXTERNAL MODULE: ./src/redux/reducers/session/reducer.ts
var session_reducer = __webpack_require__(74264);
// EXTERNAL MODULE: ./src/redux/reducers/userDiscountCode/actions.ts
var userDiscountCode_actions = __webpack_require__(80362);
// EXTERNAL MODULE: ./src/redux/reducers/userInfo/reducer.ts
var userInfo_reducer = __webpack_require__(77145);
// EXTERNAL MODULE: ./src/shared/components/AvailableCouponDialogAlert/index.ts + 2 modules
var AvailableCouponDialogAlert = __webpack_require__(71910);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/esm/ReportProblem.js
var ReportProblem = __webpack_require__(64156);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/esm/Close.js
var Close = __webpack_require__(95537);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/styled.js + 2 modules
var styled = __webpack_require__(11496);
// EXTERNAL MODULE: ./node_modules/@mui/material/Paper/Paper.js + 1 modules
var Paper = __webpack_require__(55113);
// EXTERNAL MODULE: ./node_modules/@mui/system/esm/colorManipulator.js
var colorManipulator = __webpack_require__(41796);
// EXTERNAL MODULE: ./node_modules/@mui/material/IconButton/IconButton.js + 1 modules
var IconButton = __webpack_require__(93946);
// EXTERNAL MODULE: ./node_modules/@mui/material/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(15861);
// EXTERNAL MODULE: ./node_modules/@mui/material/Grow/Grow.js
var Grow = __webpack_require__(96514);
// EXTERNAL MODULE: ./node_modules/@mui/material/Dialog/Dialog.js + 1 modules
var Dialog = __webpack_require__(50657);
// EXTERNAL MODULE: ./node_modules/@mui/material/Tooltip/Tooltip.js + 2 modules
var Tooltip = __webpack_require__(42213);
// EXTERNAL MODULE: ./node_modules/@mui/material/DialogContent/DialogContent.js + 1 modules
var DialogContent = __webpack_require__(6514);
// EXTERNAL MODULE: ./node_modules/@mui/material/Stack/Stack.js
var Stack = __webpack_require__(26447);
// EXTERNAL MODULE: ./node_modules/@mui/material/DialogActions/DialogActions.js + 1 modules
var DialogActions = __webpack_require__(31425);
// EXTERNAL MODULE: ./node_modules/@mui/material/Button/Button.js + 1 modules
var Button = __webpack_require__(11057);
// EXTERNAL MODULE: ./src/modules/assets/TicketPercentOutline.tsx
var TicketPercentOutline = __webpack_require__(94999);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/shared/components/CouponAlert/CouponAlert.tsx


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }









var DialogPaper = (0,styled/* default */.ZP)(Paper/* default */.Z)(function (_ref) {
  var _ref2;

  var theme = _ref.theme;
  return _ref2 = {
    width: 500,
    margin: '8px !important',
    overflowX: 'hidden',
    overflowY: 'hidden !important',
    borderRadius: 8
  }, (0,defineProperty/* default */.Z)(_ref2, theme.breakpoints.up('sm'), {
    '&::after': {
      content: '""',
      position: 'absolute',
      bottom: -320,
      left: -270,
      width: 490,
      height: 400,
      borderRadius: '50%',
      backgroundColor: (0,colorManipulator/* alpha */.Fq)(theme.palette.primary.main, 0.15),
      zIndex: 0
    }
  }), (0,defineProperty/* default */.Z)(_ref2, '&::before', (0,defineProperty/* default */.Z)({
    content: '""',
    position: 'absolute',
    top: -365,
    right: -105,
    width: 490,
    height: 400,
    transform: 'rotate(135deg)',
    borderRadius: '50%',
    backgroundColor: (0,colorManipulator/* alpha */.Fq)(theme.palette.primary.main, 0.15),
    zIndex: 0
  }, theme.breakpoints.down('sm'), {
    right: -275,
    top: -335,
    transform: 'rotate(0deg)'
  })), (0,defineProperty/* default */.Z)(_ref2, '& .MuiDialogContent-root', {
    padding: '40px 16px 12px',
    zIndex: 1
  }), (0,defineProperty/* default */.Z)(_ref2, '& .MuiDialogActions-root', (0,defineProperty/* default */.Z)({
    padding: '12px 16px 24px',
    zIndex: 1,
    gap: 8,
    button: {
      padding: '8px 24px'
    }
  }, theme.breakpoints.down('sm'), {
    button: {
      width: '100%'
    }
  })), _ref2;
});
var CloseButton = (0,styled/* default */.ZP)(IconButton/* default */.Z)(function () {
  return {
    position: 'absolute',
    top: 8,
    right: 8,
    zIndex: 2
  };
});
var Title = (0,styled/* default */.ZP)(Typography/* default */.Z)(function (_ref3) {
  var theme = _ref3.theme;
  return {
    fontSize: '1.125rem',
    fontWeight: 700,
    span: {
      color: theme.palette.primary.main
    }
  };
});
var Text = (0,styled/* default */.ZP)(Typography/* default */.Z)(function (_ref4) {
  var theme = _ref4.theme;
  return {
    fontSize: '1.125rem',
    textAlign: 'center',
    span: {
      fontWeight: 700,
      color: theme.palette.primary.main
    }
  };
});
var Transition = /*#__PURE__*/react.forwardRef(function Transition(props, ref) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Grow/* default */.Z, _objectSpread({
    ref: ref
  }, props));
});

var CouponAlert = function CouponAlert(_ref5) {
  var open = _ref5.open,
      onClose = _ref5.onClose,
      isError = _ref5.isError;
  var theme = (0,useTheme/* default */.Z)();

  var _useSelector = (0,es/* useSelector */.v9)(function (state) {
    return state.publicUserReducer;
  }),
      user = _useSelector.user;

  var datas = (0,react.useMemo)(function () {
    if (isError) {
      return {
        icon: /*#__PURE__*/(0,jsx_runtime.jsx)(ReportProblem/* default */.Z, {
          color: "error",
          style: {
            fontSize: 20
          }
        }),
        title: /*#__PURE__*/(0,jsx_runtime.jsxs)(Title, {
          variant: "h6",
          style: {
            fontSize: '1.125rem',
            fontWeight: 700
          },
          children: ["CUPOM", ' ', /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
            style: {
              color: theme.palette.error.main
            },
            children: "INV\xC1LIDO"
          })]
        }),
        text: /*#__PURE__*/(0,jsx_runtime.jsxs)(Text, {
          children: [user ? /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: ["Ol\xE1 ", /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
              children: user === null || user === void 0 ? void 0 : user.name
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
              children: ", n\xE3o foi poss\xEDvel"
            })]
          }) : /*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
            children: "N\xE3o foi poss\xEDvel"
          }), ' ', "aplicar esse cupom O cupom est\xE1 ", /*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
            children: "inv\xE1lido"
          }), " ou", ' ', /*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
            children: "expirado"
          }), ".", /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
            role: "img",
            "aria-label": "\xEDcone de cara triste",
            children: "\u2639\uFE0F"
          })]
        })
      };
    }

    return {
      icon: /*#__PURE__*/(0,jsx_runtime.jsx)(TicketPercentOutline/* default */.Z, {
        color: "primary",
        style: {
          fontSize: 20
        }
      }),
      title: /*#__PURE__*/(0,jsx_runtime.jsxs)(Title, {
        variant: "h6",
        style: {
          fontSize: '1.125rem',
          fontWeight: 700
        },
        children: ["CUPOM ", /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
          children: "APLICADO"
        })]
      }),
      text: user ? /*#__PURE__*/(0,jsx_runtime.jsxs)(Text, {
        children: ["Ol\xE1 ", /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
          children: user === null || user === void 0 ? void 0 : user.name
        }), ", seu cupom", ' ', /*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
          children: "foi aplicado com sucesso!"
        }), ' ', /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
          role: "img",
          "aria-label": "\xEDcone de festa",
          children: "\uD83C\uDF89"
        })]
      }) : /*#__PURE__*/(0,jsx_runtime.jsxs)(Text, {
        children: ["Seu cupom ", /*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
          children: "foi aplicado com sucesso!"
        }), ' ', /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
          role: "img",
          "aria-label": "\xEDcone de festa",
          children: "\uD83C\uDF89"
        })]
      })
    };
  }, [isError, user]); // eslint-disable-line

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(Dialog/* default */.Z, {
    open: open,
    TransitionComponent: Transition,
    PaperComponent: DialogPaper,
    onClose: onClose,
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Tooltip/* default */.Z, {
      arrow: true,
      title: "Fechar",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(CloseButton, {
        "data-testid": "close-button",
        onClick: onClose,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(Close/* default */.Z, {})
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(DialogContent/* default */.Z, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(Stack/* default */.Z, {
        direction: "row",
        alignItems: "center",
        justifyContent: "center",
        gap: 1,
        children: [datas.icon, datas.title]
      }), datas.text]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(DialogActions/* default */.Z, {
      disableSpacing: true,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Hidden/* default */.Z, {
        smDown: true,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(Button/* default */.Z, {
          variant: "outlined",
          onClick: onClose,
          children: "fechar"
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Button/* default */.Z, {
        disableElevation: true,
        variant: "contained",
        onClick: onClose,
        children: "continuar pedido"
      })]
    })]
  });
};

/* harmony default export */ var CouponAlert_CouponAlert = (CouponAlert);
;// CONCATENATED MODULE: ./src/shared/components/CouponAlert/index.ts

/* harmony default export */ var components_CouponAlert = (CouponAlert_CouponAlert);
// EXTERNAL MODULE: ./node_modules/firebase/auth/dist/index.esm.js + 1 modules
var index_esm = __webpack_require__(17702);
// EXTERNAL MODULE: ./public/svg/ColoredGoogleIcon.tsx
var ColoredGoogleIcon = __webpack_require__(29930);
// EXTERNAL MODULE: ./src/firebase/auth/index.ts + 1 modules
var auth = __webpack_require__(81467);
// EXTERNAL MODULE: ./src/firebase/providers/index.ts
var providers = __webpack_require__(5881);
// EXTERNAL MODULE: ./src/helpers/utils/index.ts + 28 modules
var utils = __webpack_require__(58679);
;// CONCATENATED MODULE: ./src/shared/components/CouponWithRequiredAuthAlert/CouponWithRequiredAuthAlert.tsx

















var CouponWithRequiredAuthAlert_DialogPaper = (0,styled/* default */.ZP)(Paper/* default */.Z)(function (_ref) {
  var theme = _ref.theme;
  return {
    width: 500,
    margin: '8px !important',
    overflowX: 'hidden',
    overflowY: 'hidden !important',
    borderRadius: 8,
    '&::before': (0,defineProperty/* default */.Z)({
      content: '""',
      position: 'absolute',
      top: -60,
      right: -210,
      width: 490,
      height: 400,
      transform: 'rotate(38deg)',
      borderRadius: '50%',
      backgroundColor: (0,colorManipulator/* alpha */.Fq)(theme.palette.primary.main, 0.15),
      zIndex: 0
    }, theme.breakpoints.down('sm'), {
      right: -395
    }),
    '&::after': {
      content: '""',
      position: 'absolute',
      bottom: -260,
      left: -275,
      width: 490,
      height: 400,
      transform: 'rotate(85deg)',
      borderRadius: '50%',
      backgroundColor: (0,colorManipulator/* alpha */.Fq)(theme.palette.primary.main, 0.15),
      zIndex: 0
    },
    '& .MuiDialogContent-root': {
      padding: '48px 16px 8px',
      zIndex: 1
    },
    '& .MuiDialogActions-root': {
      flexDirection: 'column',
      padding: '24px 16px 24px',
      zIndex: 1,
      gap: 8,
      button: {
        padding: '8px 24px'
      }
    }
  };
});
var CouponWithRequiredAuthAlert_CloseButton = (0,styled/* default */.ZP)(IconButton/* default */.Z)(function () {
  return {
    position: 'absolute',
    top: 8,
    right: 8,
    zIndex: 2
  };
});
var CouponWithRequiredAuthAlert_Title = (0,styled/* default */.ZP)(Typography/* default */.Z)(function (_ref2) {
  var theme = _ref2.theme;
  return {
    fontSize: '1.125rem',
    fontWeight: 700,
    textAlign: 'center',
    span: {
      color: theme.palette.primary.main
    }
  };
});
var IllustrationCard = (0,styled/* default */.ZP)(Stack/* default */.Z)(function (_ref3) {
  var _ref4;

  var theme = _ref3.theme;
  return _ref4 = {
    position: 'relative',
    flexDirection: 'row',
    justifyContent: 'space-between',
    minHeight: 140,
    margin: '16px 8px 0 0',
    borderRadius: 20,
    backgroundColor: theme.palette.primary.main,
    color: '#fff',
    boxShadow: "8px 8px 0 ".concat((0,colorManipulator/* alpha */.Fq)(theme.palette.primary.main, 0.25)),
    span: {
      width: 'min-content',
      fontSize: '1.125rem',
      textTransform: 'uppercase',
      fontWeight: 700,
      color: theme.palette.primary.main,
      backgroundColor: '#fff',
      padding: '6.5px 16px',
      borderRadius: 8
    }
  }, (0,defineProperty/* default */.Z)(_ref4, theme.breakpoints.down('sm'), {
    minHeight: 105,
    margin: '16px 5px 0 0',
    boxShadow: "5px 5px 0 ".concat((0,colorManipulator/* alpha */.Fq)(theme.palette.primary.main, 0.25)),
    span: {
      fontSize: '.75rem',
      padding: '0 8px'
    }
  }), (0,defineProperty/* default */.Z)(_ref4, "img", {
    position: 'absolute',
    bottom: 0,
    right: 0
  }), _ref4;
});

var CouponWithRequiredAuthAlert = function CouponWithRequiredAuthAlert(_ref5) {
  var open = _ref5.open,
      onClose = _ref5.onClose,
      closeAll = _ref5.closeAll;
  var theme = (0,useTheme/* default */.Z)();
  var dispatch = (0,es/* useDispatch */.I0)();

  var _useRouter = (0,router.useRouter)(),
      push = _useRouter.push;

  var isSm = (0,useMediaQuery/* default */.Z)(theme.breakpoints.down('sm'));

  var handleLogin = function handleLogin() {
    (0,index_esm/* signInWithPopup */.rh)(auth/* auth */.I, providers/* googleAuthProvider */.q).then(function (userCredentials) {
      userCredentials.user.getIdToken().then( /*#__PURE__*/function () {
        var _ref6 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(token) {
          var userExists, _userCredentials$user, email, name;

          return regenerator_default().wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  _context.next = 2;
                  return (0,utils/* SocialSignIn */.WK)(token, userCredentials);

                case 2:
                  userExists = _context.sent;

                  if (userExists) {
                    closeAll();
                    push('/');
                  } else {
                    _userCredentials$user = userCredentials.user, email = _userCredentials$user.email, name = _userCredentials$user.displayName;
                    closeAll();
                    push({
                      pathname: '/login',
                      query: {
                        name: name,
                        email: email
                      }
                    }, '/login');
                  }

                case 4:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }));

        return function (_x) {
          return _ref6.apply(this, arguments);
        };
      }());
    })["catch"](function (err) {
      console.log(err.message);
    });
  };

  var handleClose = function handleClose() {
    dispatch((0,reducer/* setCouponAwaitingAuth */.UK)(undefined));
    onClose();
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(Dialog/* default */.Z, {
    open: open,
    PaperComponent: CouponWithRequiredAuthAlert_DialogPaper,
    onClose: handleClose,
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Tooltip/* default */.Z, {
      arrow: true,
      title: "Fechar",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(CouponWithRequiredAuthAlert_CloseButton, {
        onClick: handleClose,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(Close/* default */.Z, {})
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(DialogContent/* default */.Z, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(CouponWithRequiredAuthAlert_Title, {
        variant: "h6",
        children: ["CUPOM DE ", /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
          children: "DESCONTO"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Typography/* default */.Z, {
        style: {
          fontSize: !isSm ? '1.125rem' : undefined,
          fontWeight: 400,
          textAlign: 'center'
        },
        children: ["Para ", /*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
          children: "usar o cupom e ganhar desconto"
        }), " no pedido", ' ', /*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
          children: "fa\xE7a login em sua conta"
        }), " no card\xE1pio.", ' ', /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
          role: "img",
          "aria-label": "rosto com olhar maravilhado",
          children: "\uD83E\uDD29"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(IllustrationCard, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(Box/* default */.Z, {
          padding: isSm ? '16px 105px 16px 24px' : '24px 0 24px 32px',
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(Stack/* default */.Z, {
            mb: isSm ? 1 : 2,
            direction: "row",
            alignItems: "center",
            gap: 1,
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
              children: "cupom:"
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(TicketPercentOutline/* default */.Z, {
              style: {
                fontSize: isSm ? 20 : 32
              }
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(Typography/* default */.Z, {
            style: {
              fontSize: isSm ? '1.125rem' : '1.25rem',
              fontWeight: 700
            },
            children: "DESCONTO NO PEDIDO!"
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Hidden/* default */.Z, {
          smDown: true,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
            src: "/svg/woman-illustration.svg",
            alt: "Ilustra\xE7\xE3o"
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Hidden/* default */.Z, {
          smUp: true,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
            src: "/svg/woman-illustration-mobile.svg",
            alt: "Ilustra\xE7\xE3o"
          })
        })]
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(DialogActions/* default */.Z, {
      disableSpacing: true,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Button/* default */.Z, {
        fullWidth: true,
        disableElevation: true,
        variant: "contained",
        onClick: function onClick() {
          closeAll();
          push('/login');
        },
        children: "fazer login"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Button/* default */.Z, {
        fullWidth: true,
        variant: "outlined",
        color: "primary",
        onClick: handleLogin,
        startIcon: /*#__PURE__*/(0,jsx_runtime.jsx)(ColoredGoogleIcon/* default */.Z, {}),
        children: "continuar com google"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Button/* default */.Z, {
        fullWidth: true,
        onClick: handleClose,
        children: "continuar sem cupom"
      })]
    })]
  });
};

/* harmony default export */ var CouponWithRequiredAuthAlert_CouponWithRequiredAuthAlert = (CouponWithRequiredAuthAlert);
;// CONCATENATED MODULE: ./src/shared/components/CouponWithRequiredAuthAlert/index.ts

/* harmony default export */ var components_CouponWithRequiredAuthAlert = (CouponWithRequiredAuthAlert_CouponWithRequiredAuthAlert);
// EXTERNAL MODULE: ./src/shared/services/authService.ts
var authService = __webpack_require__(25137);
// EXTERNAL MODULE: ./src/shared/services/publicSession.ts
var publicSession = __webpack_require__(83033);
// EXTERNAL MODULE: ./src/zustand/couponWithRequiredAuth.ts
var couponWithRequiredAuth = __webpack_require__(96725);
// EXTERNAL MODULE: ./src/zustand/readOnly.ts
var readOnly = __webpack_require__(39383);
;// CONCATENATED MODULE: ./src/modules/assets/SpeechBubbleTriangle.tsx



var SpeechBubbleTriangle = function SpeechBubbleTriangle(_ref) {
  var color = _ref.color;
  return /*#__PURE__*/(0,jsx_runtime.jsx)("svg", {
    width: "21",
    height: "17",
    viewBox: "0 0 21 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M11.2583 16.5C10.8734 17.1667 9.91118 17.1667 9.52628 16.5L0.866025 1.5C0.481125 0.833333 0.96225 8.41226e-08 1.73205 1.51421e-07L19.0526 1.66563e-06C19.8224 1.73293e-06 20.3035 0.833335 19.9186 1.5L11.2583 16.5Z",
      fill: color
    })
  });
};

/* harmony default export */ var assets_SpeechBubbleTriangle = (SpeechBubbleTriangle);
;// CONCATENATED MODULE: ./src/containers/IndexContainer/components/CartWithItemsSpeechBubble/CartWithItemsSpeechBubble.tsx







var useStyles = (0,makeStyles/* default */.Z)(function (theme) {
  return {
    root: (0,defineProperty/* default */.Z)({
      width: 200,
      position: 'fixed',
      right: 180,
      top: 90,
      maxWidth: 200,
      backgroundColor: theme.palette.primary.main,
      padding: 10,
      borderRadius: 4,
      zIndex: 10
    }, theme.breakpoints.down('sm'), {
      position: 'fixed',
      right: 'calc(50% - 100px)',
      bottom: 140,
      top: 'auto'
    }),
    triangleContainer: (0,defineProperty/* default */.Z)({
      position: 'absolute',
      right: 1,
      top: -19,
      transform: 'rotate(180deg)'
    }, theme.breakpoints.down('sm'), {
      right: 'calc(50% - 10px)',
      top: 'unset',
      bottom: -19,
      transform: 'rotate(0deg)'
    })
  };
});

var CartWithItemsSpeechBubble = function CartWithItemsSpeechBubble(_ref) {
  var show = _ref.show;
  var classes = useStyles();
  var theme = (0,useTheme/* default */.Z)();
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Grow/* default */.Z, {
    "in": show,
    mountOnEnter: true,
    unmountOnExit: true,
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Box/* default */.Z, {
      className: classes.root,
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(Typography/* default */.Z, {
        style: {
          color: 'white',
          textAlign: 'center'
        },
        children: ["Um item foi adicionado ao seu carrinho", ' ', /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
          role: "img",
          "aria-label": "rosto com olho piscando",
          children: "\uD83D\uDE09"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Box/* default */.Z, {
        className: classes.triangleContainer,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(assets_SpeechBubbleTriangle, {
          color: theme.palette.primary.main
        })
      })]
    })
  });
};

/* harmony default export */ var CartWithItemsSpeechBubble_CartWithItemsSpeechBubble = (CartWithItemsSpeechBubble);
;// CONCATENATED MODULE: ./src/containers/IndexContainer/components/CartWithItemsSpeechBubble/index.ts

/* harmony default export */ var components_CartWithItemsSpeechBubble = (CartWithItemsSpeechBubble_CartWithItemsSpeechBubble);
// EXTERNAL MODULE: ./node_modules/@mui/material/Grid/Grid.js + 2 modules
var Grid = __webpack_require__(86886);
// EXTERNAL MODULE: ./node_modules/formik/dist/formik.esm.js + 121 modules
var formik_esm = __webpack_require__(82580);
// EXTERNAL MODULE: ./src/shared/services/scoredSearch.ts
var scoredSearch = __webpack_require__(91340);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/esm/LocalOffer.js
var LocalOffer = __webpack_require__(39243);
// EXTERNAL MODULE: ./node_modules/@mui/material/colors/grey.js
var grey = __webpack_require__(47036);
// EXTERNAL MODULE: ./node_modules/@mui/material/colors/green.js
var green = __webpack_require__(13486);
// EXTERNAL MODULE: ./node_modules/@wls-solucoes/lets-eat-types/dist/lets-eat-types.esm.js
var lets_eat_types_esm = __webpack_require__(14137);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/react-scroll/modules/index.js
var modules = __webpack_require__(66261);
// EXTERNAL MODULE: ./node_modules/react-transition-group/esm/TransitionGroup.js + 1 modules
var TransitionGroup = __webpack_require__(73350);
// EXTERNAL MODULE: ./src/modules/assets/bored-cat.tsx
var bored_cat = __webpack_require__(4805);
// EXTERNAL MODULE: ./src/redux/reducers/catalog/reducer.ts
var catalog_reducer = __webpack_require__(34765);
// EXTERNAL MODULE: ./src/redux/reducers/recommendation/reducer.ts
var recommendation_reducer = __webpack_require__(89985);
// EXTERNAL MODULE: ./src/redux/reducers/search/reducer.ts
var search_reducer = __webpack_require__(23054);
// EXTERNAL MODULE: ./src/shared/components/BackdropProgressIndicator/index.ts + 1 modules
var BackdropProgressIndicator = __webpack_require__(91843);
// EXTERNAL MODULE: ./src/shared/components/NoItemsFound/index.ts + 2 modules
var NoItemsFound = __webpack_require__(4190);
// EXTERNAL MODULE: ./src/shared/services/establishment.ts
var services_establishment = __webpack_require__(42768);
// EXTERNAL MODULE: ./node_modules/@mui/material/Card/Card.js + 1 modules
var Card = __webpack_require__(66242);
// EXTERNAL MODULE: ./node_modules/react-lazy-load-image-component/build/index.js
var build = __webpack_require__(72679);
// EXTERNAL MODULE: ./node_modules/sweetalert2/dist/sweetalert2.all.js
var sweetalert2_all = __webpack_require__(86455);
var sweetalert2_all_default = /*#__PURE__*/__webpack_require__.n(sweetalert2_all);
// EXTERNAL MODULE: ./src/helpers/hooks/index.ts + 12 modules
var hooks = __webpack_require__(58404);
;// CONCATENATED MODULE: ./src/containers/IndexContainer/components/Catalog/components/CatalogItens/components/CatalogIten/CatalogIten.tsx













var CatalogIten_useStyles = (0,makeStyles/* default */.Z)(function (theme) {
  return {
    root: {
      width: '100%',
      flexDirection: 'column'
    },
    card: (0,defineProperty/* default */.Z)({
      width: '100%',
      height: 173,
      transition: 'background-color .4s',
      cursor: 'pointer',
      '&:hover': {
        backgroundColor: "".concat(theme.palette.primary.main, "15")
      },
      '&:active': {
        backgroundColor: "".concat(theme.palette.primary.main, "25")
      }
    }, theme.breakpoints.down('sm'), {
      height: function height(_ref) {
        var isPromotion = _ref.isPromotion;
        return !isPromotion ? 'unset' : undefined;
      },
      borderRadius: function borderRadius(_ref2) {
        var isPromotion = _ref2.isPromotion;
        return isPromotion ? 'auto' : 0;
      },
      border: function border(_ref3) {
        var isPromotion = _ref3.isPromotion;
        return isPromotion ? 'auto' : 'none';
      }
    }),
    itemInfoContainer: (0,defineProperty/* default */.Z)({
      height: 173,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      padding: 16
    }, theme.breakpoints.down('sm'), {
      height: 'unset',
      padding: '16px 8px'
    }),
    itemName: {
      fontSize: 16,
      fontWeight: 600,
      marginBottom: 8,
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      display: '-webkit-box',
      '-webkit-line-clamp': 2,
      'line-clamp': 2,
      '-webkit-box-orient': 'vertical'
    },
    itemDescription: {
      fontSize: 14,
      fontWeight: 400,
      color: grey/* default.600 */.Z[600],
      marginBottom: 8,
      display: '-webkit-box',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      '-webkit-line-clamp': 3,
      'line-clamp': 3,
      '-webkit-box-orient': 'vertical'
    }
  };
});

var OrderItemCard = function OrderItemCard(_ref4) {
  var item = _ref4.item,
      _ref4$isOnOpeningHour = _ref4.isOnOpeningHours,
      isOnOpeningHours = _ref4$isOnOpeningHour === void 0 ? true : _ref4$isOnOpeningHour,
      categoryGuid = _ref4.categoryGuid,
      handleSelectItem = _ref4.handleSelectItem,
      isPromotion = _ref4.isPromotion;
  var classes = CatalogIten_useStyles({
    isPromotion: isPromotion
  });
  var theme = (0,useTheme/* default */.Z)();

  var _useEventHandler = (0,hooks/* useEventHandler */.xd)(),
      eventHandler = _useEventHandler.eventHandler;

  var isXs = (0,useMediaQuery/* default */.Z)(theme.breakpoints.down('xs'));
  var isMd = (0,useMediaQuery/* default */.Z)(theme.breakpoints.up('md'));

  var onClickItem = function onClickItem() {
    var eventOptions = {
      value: item.price,
      item: {
        item_id: item.guid,
        item_name: item.name,
        item_category: categoryGuid
      }
    };

    if (isOnOpeningHours) {
      handleSelectItem(item.guid);

      if (isPromotion) {
        eventHandler.selectPromotion(eventOptions.item);
      } else {
        eventHandler.viewItem(eventOptions);
      }
    } else {
      sweetalert2_all_default().fire({
        title: 'Ops!',
        text: 'Item não disponível no momento',
        icon: 'warning'
      });
    }
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(Box/* default */.Z, {
    className: classes.root,
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Card/* default */.Z, {
      "data-testid": "catalog-item",
      variant: "outlined",
      className: classes.card,
      onClick: onClickItem,
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Box/* default */.Z, {
        className: classes.itemInfoContainer,
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(Box/* default */.Z, {
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
          height: "100%",
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(Box/* default */.Z, {
            style: {
              wordBreak: 'break-word'
            },
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Typography/* default */.Z, {
              "data-testid": "catalog-item-name",
              className: classes.itemName,
              style: {
                opacity: !isOnOpeningHours ? 0.5 : undefined,
                textDecoration: !isOnOpeningHours ? 'line-through' : undefined
              },
              children: item.name
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(Typography/* default */.Z, {
              className: classes.itemDescription,
              style: {
                textDecoration: !isOnOpeningHours ? 'line-through' : undefined
              },
              children: item.description
            })]
          }), item.promotionalPrice === undefined ? /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: item.price !== 0 && /*#__PURE__*/(0,jsx_runtime.jsx)(Typography/* default */.Z, {
              "data-testid": "min-item-price",
              variant: "h6",
              style: !isOnOpeningHours ? {
                opacity: 0.5,
                textDecoration: 'line-through'
              } : undefined,
              children: (0,utils/* toCurrencyValue */.y6)(item.price)
            })
          }) : /*#__PURE__*/(0,jsx_runtime.jsxs)(Box/* default */.Z, {
            "data-testid": "promotion-price-container",
            display: "flex",
            alignItems: "center",
            style: {
              gap: '4px',
              flexWrap: 'wrap'
            },
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Typography/* default */.Z, {
              "data-testid": "min-promo-price",
              variant: "h6",
              style: {
                fontWeight: 'bold',
                color: green/* default.500 */.Z[500],
                opacity: !isOnOpeningHours ? 0.5 : undefined,
                textDecoration: !isOnOpeningHours ? 'line-through' : undefined
              },
              children: (0,utils/* toCurrencyValue */.y6)(item.promotionalPrice)
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(Typography/* default */.Z, {
              style: {
                fontSize: '1rem',
                color: '#ccc',
                textDecoration: 'line-through'
              },
              children: (0,utils/* toCurrencyValue */.y6)(item.price)
            })]
          })]
        }), item.thumbCoverImage !== undefined || item.flavors ? /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
          "data-testid": "catalog-item-image-container",
          style: {
            minWidth: isMd ? 141 : 74,
            opacity: !isOnOpeningHours ? 0.5 : undefined
          },
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(build.LazyLoadImage, {
            width: isMd ? 141 : 74,
            height: isMd ? 141 : 74,
            src: item.flavors ? "/images/pizza-flavors-".concat(item.flavors, ".png") : item.thumbCoverImage,
            alt: "Imagem do produto",
            style: {
              borderRadius: 8,
              objectFit: 'cover'
            }
          })
        }) : null]
      })
    }), item.promotionPercentage && /*#__PURE__*/(0,jsx_runtime.jsxs)(Box/* default */.Z, {
      "data-testid": "promotion-container",
      display: "flex",
      alignItems: "center",
      style: {
        width: isXs ? 'fit-content' : '100%',
        backgroundColor: '#E9F5EC',
        padding: !isXs ? 8 : '5px 10px',
        borderRadius: isXs ? 4 : '0 0 4px 4px',
        marginTop: isXs ? 16 : undefined
      },
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(LocalOffer/* default */.Z, {
        style: {
          color: green/* default.600 */.Z[600],
          marginRight: 5,
          fontSize: 15
        }
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Typography/* default */.Z, {
        style: {
          color: green/* default.600 */.Z[600],
          fontWeight: 600,
          fontSize: '.875rem'
        },
        children: ["At\xE9 ", item.promotionPercentage, "% de desconto"]
      })]
    })]
  });
};

/* harmony default export */ var CatalogIten = (OrderItemCard);
;// CONCATENATED MODULE: ./src/containers/IndexContainer/components/Catalog/components/CatalogItens/components/CatalogIten/index.ts

/* harmony default export */ var components_CatalogIten = (CatalogIten);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/esm/Add.js
var Add = __webpack_require__(72428);
// EXTERNAL MODULE: ./node_modules/@mui/material/Slide/Slide.js
var Slide = __webpack_require__(54776);
;// CONCATENATED MODULE: ./src/containers/IndexContainer/components/Catalog/components/CatalogItens/components/ItemRecommendationDialog/ItemRecommendationDialog.tsx


function ItemRecommendationDialog_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function ItemRecommendationDialog_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ItemRecommendationDialog_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ItemRecommendationDialog_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }







var ItemRecommendationDialog_useStyles = (0,makeStyles/* default */.Z)(function (theme) {
  return {
    noThanks: {
      width: 'max-content',
      fontSize: '.875rem',
      color: theme.palette.primary.main,
      textTransform: 'uppercase',
      margin: '24px auto 0 auto',
      '&:hover': {
        cursor: 'pointer',
        textDecoration: 'underline'
      }
    }
  };
});
var ItemRecommendationDialog_Transition = /*#__PURE__*/react.forwardRef(function Transition(props, ref) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Slide/* default */.Z, ItemRecommendationDialog_objectSpread({
    direction: "up",
    ref: ref
  }, props));
});

var ItemRecommendationDialog = function ItemRecommendationDialog(_ref) {
  var _recommendedItem$item;

  var open = _ref.open,
      recommendedItem = _ref.recommendedItem,
      onIWantClick = _ref.onIWantClick,
      onClose = _ref.onClose;
  var classes = ItemRecommendationDialog_useStyles();
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(Dialog/* default */.Z, {
    open: open,
    onBackdropClick: onClose,
    onClose: onClose,
    TransitionComponent: ItemRecommendationDialog_Transition,
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(Box/* default */.Z, {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      padding: "24px 32px",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Typography/* default */.Z, {
        style: {
          fontSize: '1.5rem',
          fontWeight: 600
        },
        children: "Pe\xE7a tamb\xE9m"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Tooltip/* default */.Z, {
        arrow: true,
        title: "Fechar",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(IconButton/* default */.Z, {
          onClick: onClose,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(Close/* default */.Z, {})
        })
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(DialogContent/* default */.Z, {
      style: {
        padding: 0
      },
      children: [(recommendedItem === null || recommendedItem === void 0 ? void 0 : recommendedItem.imageUrl) && /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
        width: "100%",
        height: 275,
        src: recommendedItem.imageUrl,
        alt: "Imagem de ".concat((_recommendedItem$item = recommendedItem === null || recommendedItem === void 0 ? void 0 : recommendedItem.itemName) !== null && _recommendedItem$item !== void 0 ? _recommendedItem$item : ''),
        style: {
          objectFit: 'contain'
        }
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Box/* default */.Z, {
        padding: 4,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Typography/* default */.Z, {
          variant: "h6",
          style: {
            fontWeight: 'bold'
          },
          children: recommendedItem === null || recommendedItem === void 0 ? void 0 : recommendedItem.itemName
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Typography/* default */.Z, {
          style: {
            fontWeight: 400
          },
          children: recommendedItem === null || recommendedItem === void 0 ? void 0 : recommendedItem.itemDescription
        })]
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(DialogActions/* default */.Z, {
      style: {
        display: 'block',
        padding: '0 32px 32px'
      },
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Button/* default */.Z, {
        fullWidth: true,
        variant: "contained",
        color: "primary",
        startIcon: /*#__PURE__*/(0,jsx_runtime.jsx)(Add/* default */.Z, {}),
        onClick: onIWantClick,
        children: "sim, quero!"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Typography/* default */.Z, {
        className: classes.noThanks,
        onClick: onClose,
        children: "n\xE3o, obrigado"
      })]
    })]
  });
};

/* harmony default export */ var ItemRecommendationDialog_ItemRecommendationDialog = (ItemRecommendationDialog);
;// CONCATENATED MODULE: ./src/containers/IndexContainer/components/Catalog/components/CatalogItens/components/ItemRecommendationDialog/index.ts

/* harmony default export */ var components_ItemRecommendationDialog = (ItemRecommendationDialog_ItemRecommendationDialog);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/esm/Remove.js
var Remove = __webpack_require__(38679);
// EXTERNAL MODULE: ./node_modules/@mui/material/Accordion/Accordion.js + 1 modules
var Accordion = __webpack_require__(67358);
// EXTERNAL MODULE: ./node_modules/@mui/material/AccordionSummary/AccordionSummary.js + 1 modules
var AccordionSummary = __webpack_require__(38895);
// EXTERNAL MODULE: ./node_modules/@mui/material/AccordionDetails/AccordionDetails.js + 1 modules
var AccordionDetails = __webpack_require__(22797);
// EXTERNAL MODULE: ./node_modules/@mui/material/Divider/Divider.js
var Divider = __webpack_require__(67720);
;// CONCATENATED MODULE: ./src/containers/IndexContainer/components/Catalog/components/CatalogItens/components/OrderCategoryAccordion/OrderCategoryAccordion.tsx










var OrderCategoryAccordion_useStyles = (0,makeStyles/* default */.Z)(function () {
  return {
    categoryName: {
      display: '-webkit-box',
      overflow: 'hidden',
      fontSize: '1.125rem',
      fontWeight: 'bold',
      wordBreak: 'break-word'
    },
    productList: {
      display: 'flex',
      flexDirection: 'column',
      padding: '8px 0'
    }
  };
});

var OrderCategoryAccordion = function OrderCategoryAccordion(_ref) {
  var _catalog$find$expande, _catalog$find;

  var category = _ref.category,
      _handleSelectItem = _ref.handleSelectItem;
  var classes = OrderCategoryAccordion_useStyles();
  var dispatch = (0,es/* useDispatch */.I0)();

  var _useSelector = (0,es/* useSelector */.v9)(function (state) {
    return state.searchReducer;
  }),
      search = _useSelector.search;

  var _useSelector2 = (0,es/* useSelector */.v9)(function (state) {
    return state.catalogReducer;
  }),
      catalog = _useSelector2.catalog;

  var _useSelector3 = (0,es/* useSelector */.v9)(function (state) {
    return state.establishmentReducer;
  }),
      establishment = _useSelector3.establishment;

  var expanded = (_catalog$find$expande = catalog === null || catalog === void 0 ? void 0 : (_catalog$find = catalog.find(function (c) {
    return c.guid === category.guid;
  })) === null || _catalog$find === void 0 ? void 0 : _catalog$find.expanded) !== null && _catalog$find$expande !== void 0 ? _catalog$find$expande : false;

  var _useState = (0,react.useState)(search),
      lastSearchValue = _useState[0],
      setLastSearchValue = _useState[1];

  (0,react.useEffect)(function () {
    if (search && search !== lastSearchValue) {
      dispatch((0,catalog_reducer/* changeExpandedCategory */.dM)({
        guid: category.guid,
        value: true
      }));
    } else {
      var _ref2;

      dispatch((0,catalog_reducer/* changeExpandedCategory */.dM)({
        guid: category.guid,
        value: (_ref2 = (establishment === null || establishment === void 0 ? void 0 : establishment.webSettings.itemDisplayModeInCategory) === lets_eat_types_esm/* ItemDisplayModeInCategory.open */.Ck.open) !== null && _ref2 !== void 0 ? _ref2 : false
      }));
    }

    setLastSearchValue(search);
  }, [search]);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(Box/* default */.Z, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(Accordion/* default */.Z, {
      "data-testid": "category-accordion",
      square: true,
      elevation: 0,
      variant: "elevation",
      expanded: expanded,
      onChange: function onChange() {
        return dispatch((0,catalog_reducer/* changeExpandedCategory */.dM)({
          guid: category.guid,
          value: !expanded
        }));
      },
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(AccordionSummary/* default */.Z, {
        expandIcon: expanded ? /*#__PURE__*/(0,jsx_runtime.jsx)(Remove/* default */.Z, {
          color: "primary"
        }) : /*#__PURE__*/(0,jsx_runtime.jsx)(Add/* default */.Z, {
          color: "primary"
        }),
        style: {
          padding: '0 8px'
        },
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Box/* default */.Z, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Typography/* default */.Z, {
            className: classes.categoryName,
            style: {
              opacity: !category.isOnOpeningHours ? 0.5 : undefined,
              textDecoration: !category.isOnOpeningHours ? 'line-through' : undefined
            },
            children: category.name
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(Typography/* default */.Z, {
            "data-testid": "category-description",
            style: {
              fontSize: '.875rem',
              color: '#808080',
              wordBreak: 'break-word',
              opacity: !category.isOnOpeningHours ? 0.5 : undefined,
              textDecoration: !category.isOnOpeningHours ? 'line-through' : undefined
            },
            children: category.description
          })]
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(AccordionDetails/* default */.Z, {
        className: classes.productList,
        children: expanded && category.items.map(function (item, index) {
          var _category$guid;

          return /*#__PURE__*/(0,jsx_runtime.jsxs)(Box/* default */.Z, {
            "data-testid": "item-container",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(components_CatalogIten, {
              isOnOpeningHours: category.isOnOpeningHours,
              item: item,
              categoryGuid: (_category$guid = category.guid) !== null && _category$guid !== void 0 ? _category$guid : '',
              handleSelectItem: function handleSelectItem(guid) {
                return _handleSelectItem(guid, category.categoryType);
              }
            }), index !== category.items.length - 1 && /*#__PURE__*/(0,jsx_runtime.jsx)(Divider/* default */.Z, {})]
          }, item.guid);
        })
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Divider/* default */.Z, {})]
  });
};

/* harmony default export */ var OrderCategoryAccordion_OrderCategoryAccordion = (OrderCategoryAccordion);
;// CONCATENATED MODULE: ./src/containers/IndexContainer/components/Catalog/components/CatalogItens/components/OrderCategoryAccordion/index.ts

/* harmony default export */ var components_OrderCategoryAccordion = (OrderCategoryAccordion_OrderCategoryAccordion);
;// CONCATENATED MODULE: ./src/containers/IndexContainer/components/Catalog/components/CatalogItens/components/Promotions/Promotions.tsx








var Promotions_useStyles = (0,makeStyles/* default */.Z)(function (theme) {
  return {
    title: {
      fontSize: '14px',
      fontWeight: 600,
      lineHeight: '29px'
    },
    description: {
      fontSize: 14,
      fontWeight: 500,
      lineHeight: '20px',
      color: grey/* default.600 */.Z[600],
      marginBottom: 16,
      marginLeft: 10
    },
    container: {
      alignItems: 'flex-end',
      flexWrap: 'nowrap',
      overflowX: 'auto',
      paddingLeft: 10,
      paddingRight: 10,
      width: '100vw',
      msOverflowStyle: 'none',
      scrollbarWidth: 'none',
      '&::-webkit-scrollbar': {
        display: 'none'
      }
    },
    gridItem: {
      minWidth: '75vw',
      '& + &': {
        marginLeft: 8
      }
    }
  };
});

var Promotions = function Promotions(_ref) {
  var items = _ref.items,
      _handleSelectItem = _ref.handleSelectItem;
  var classes = Promotions_useStyles();
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(Box/* default */.Z, {
    style: {
      padding: '16px 0 24px 0',
      borderBottom: '1px solid #dedede'
    },
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(Box/* default */.Z, {
      style: {
        display: 'flex',
        marginBottom: 8,
        marginLeft: 10
      },
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Box/* default */.Z, {
        "data-testid": "category-promotion-indicator",
        style: {
          background: 'rgba(233, 245, 236, 0.75)',
          padding: 4,
          marginRight: 8,
          borderRadius: 4,
          maxHeight: 28
        },
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(LocalOffer/* default */.Z, {
          style: {
            color: green/* default.600 */.Z[600],
            fontSize: 20
          }
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Typography/* default */.Z, {
        className: classes.title,
        children: "Destaques"
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Typography/* default */.Z, {
      className: classes.description,
      children: "Produtos em promo\xE7\xE3o"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Grid/* default */.ZP, {
      container: true,
      className: classes.container,
      children: items.map(function (_ref2) {
        var product = _ref2.product,
            catalogItemGuid = _ref2.catalogItemGuid,
            catalogItemType = _ref2.catalogItemType;
        return /*#__PURE__*/(0,jsx_runtime.jsx)(Grid/* default */.ZP, {
          item: true,
          className: classes.gridItem,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(components_CatalogIten, {
            item: product,
            categoryGuid: catalogItemGuid,
            handleSelectItem: function handleSelectItem(guid) {
              return _handleSelectItem(guid, catalogItemType);
            },
            isPromotion: true
          })
        }, product.guid);
      })
    })]
  });
};

/* harmony default export */ var Promotions_Promotions = (Promotions);
;// CONCATENATED MODULE: ./src/containers/IndexContainer/components/Catalog/components/CatalogItens/components/Promotions/index.ts

/* harmony default export */ var components_Promotions = (Promotions_Promotions);
// EXTERNAL MODULE: ./node_modules/@mui/material/Skeleton/Skeleton.js + 2 modules
var Skeleton = __webpack_require__(88078);
;// CONCATENATED MODULE: ./src/containers/IndexContainer/components/Catalog/components/CatalogItens/components/SkeletonLoading/components/RandomNumberOfItens/RandomNumberOfItens.tsx





var RandomNumberOfItens = function RandomNumberOfItens() {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
    children: Array.from(Array(Math.floor(Math.random() * 4) + 6).keys()).map(function (_, key) {
      return /*#__PURE__*/(0,jsx_runtime.jsx)(Grid/* default */.ZP, {
        item: true,
        sm: 6,
        md: 4,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
          variant: "rectangular",
          width: "100%",
          height: 173,
          style: {
            borderRadius: 8
          }
        })
      }, key);
    })
  });
};

/* harmony default export */ var RandomNumberOfItens_RandomNumberOfItens = (/*#__PURE__*/(0,react.memo)(RandomNumberOfItens));
;// CONCATENATED MODULE: ./src/containers/IndexContainer/components/Catalog/components/CatalogItens/components/SkeletonLoading/components/RandomNumberOfItens/index.ts

/* harmony default export */ var components_RandomNumberOfItens = (RandomNumberOfItens_RandomNumberOfItens);
;// CONCATENATED MODULE: ./src/containers/IndexContainer/components/Catalog/components/CatalogItens/components/SkeletonLoading/components/RandomNumberOfItensSmall/RandomNumberOfItensSmall.tsx






var RandomNumberOfItensSmall = function RandomNumberOfItensSmall(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
    children: Array.from(Array(Math.floor(Math.random() * 4) + 6).keys()).map(function (_, key) {
      return /*#__PURE__*/(0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
        item: true,
        xs: 12,
        style: {
          borderBottom: '1px solid #CCCCCC',
          padding: '12px 8px',
          position: 'relative'
        },
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
          variant: "rectangular",
          width: Math.random() * 100 + 50,
          height: 24,
          style: {
            borderRadius: 16
          }
        }), Math.floor(Math.random() * 10) < 6 && /*#__PURE__*/(0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
          variant: "rectangular",
          width: Math.random() * 100 + 150,
          height: 24,
          style: {
            marginTop: 8,
            borderRadius: 8
          }
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Box/* default */.Z, {
          style: {
            position: 'absolute',
            right: 8,
            bottom: '50%',
            transform: 'translateY(50%)'
          },
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
            variant: "circular",
            width: 24,
            height: 24
          })
        })]
      }, key);
    })
  });
};

/* harmony default export */ var RandomNumberOfItensSmall_RandomNumberOfItensSmall = (/*#__PURE__*/(0,react.memo)(RandomNumberOfItensSmall));
;// CONCATENATED MODULE: ./src/containers/IndexContainer/components/Catalog/components/CatalogItens/components/SkeletonLoading/components/RandomNumberOfItensSmall/index.ts

/* harmony default export */ var components_RandomNumberOfItensSmall = (RandomNumberOfItensSmall_RandomNumberOfItensSmall);
;// CONCATENATED MODULE: ./src/containers/IndexContainer/components/Catalog/components/CatalogItens/components/SkeletonLoading/SkeletonLoading.tsx








var SkeletonLoading = function SkeletonLoading(_ref) {
  var isXs = _ref.isXs;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(Box/* default */.Z, {
    "data-testid": "loading-container",
    children: [isXs && /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(Box/* default */.Z, {
        "data-testid": "mobile-variant-indicator",
        style: {
          display: 'flex'
        },
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
          variant: "rectangular",
          width: 29,
          height: 29,
          style: {
            marginRight: 8
          }
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
          variant: "rectangular",
          width: 110,
          height: 29,
          style: {
            marginBottom: 8
          }
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
        variant: "rectangular",
        width: Math.random() * 350 + 100,
        height: 20,
        style: {
          marginBottom: 24
        }
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Grid/* default */.ZP, {
      container: true,
      spacing: isXs ? 4 : 0,
      columns: 12,
      children: isXs ? /*#__PURE__*/(0,jsx_runtime.jsx)(components_RandomNumberOfItens, {}) : /*#__PURE__*/(0,jsx_runtime.jsx)(components_RandomNumberOfItensSmall, {})
    }), isXs && /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
        variant: "rectangular",
        width: 210,
        height: 29,
        style: {
          marginBottom: 8,
          marginTop: 48
        }
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
        variant: "rectangular",
        width: Math.random() * 150 + 100,
        height: 20,
        style: {
          marginBottom: 24
        }
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Grid/* default */.ZP, {
      container: true,
      spacing: isXs ? 4 : 0,
      columns: 12,
      children: isXs ? /*#__PURE__*/(0,jsx_runtime.jsx)(components_RandomNumberOfItens, {}) : /*#__PURE__*/(0,jsx_runtime.jsx)(components_RandomNumberOfItensSmall, {})
    })]
  });
};

/* harmony default export */ var SkeletonLoading_SkeletonLoading = (SkeletonLoading);
;// CONCATENATED MODULE: ./src/containers/IndexContainer/components/Catalog/components/CatalogItens/components/SkeletonLoading/index.ts

/* harmony default export */ var components_SkeletonLoading = (SkeletonLoading_SkeletonLoading);
;// CONCATENATED MODULE: ./src/containers/IndexContainer/components/Catalog/components/CatalogItens/CatalogItens.tsx




function CatalogItens_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function CatalogItens_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? CatalogItens_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : CatalogItens_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }




























var OrderItemDialog = dynamic_default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(210), __webpack_require__.e(85), __webpack_require__.e(338), __webpack_require__.e(918)]).then(__webpack_require__.bind(__webpack_require__, 89052));
}, {
  loading: function loading() {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(BackdropProgressIndicator/* default */.Z, {});
  },
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(89052)];
    }
  }
});
var CatalogItens_useStyles = (0,makeStyles/* default */.Z)(function (theme) {
  return {
    root: {
      marginTop: 8
    },
    category: {
      '& + &': {
        marginTop: 48
      }
    },
    title: {
      fontSize: 24,
      fontWeight: 600,
      lineHeight: '29px'
    },
    description: {
      fontSize: 16,
      fontWeight: 500,
      lineHeight: '20px',
      color: grey/* default.600 */.Z[600],
      marginBottom: 24,
      wordBreak: 'break-word'
    },
    catalogItens: {
      display: 'flex',
      gap: 32,
      flexWrap: 'wrap'
    }
  };
});

var CatalogItens = function CatalogItens(_ref) {
  var formik = _ref.formik,
      catalogItensFiltered = _ref.catalogItensFiltered;
  var classes = CatalogItens_useStyles();
  var dispatch = (0,es/* useDispatch */.I0)();

  var _useRouter = (0,router.useRouter)(),
      push = _useRouter.push;

  var values = formik.values,
      setFieldValue = formik.setFieldValue;
  var isXs = (0,useMediaQuery/* default */.Z)('(min-width:600px)');

  var _useSelector = (0,es/* useSelector */.v9)(function (state) {
    return state.establishmentReducer;
  }),
      establishment = _useSelector.establishment;

  var _useSelector2 = (0,es/* useSelector */.v9)(function (state) {
    return state.searchReducer;
  }),
      search = _useSelector2.search;

  var _useSelector3 = (0,es/* useSelector */.v9)(function (state) {
    return state.catalogReducer;
  }),
      catalog = _useSelector3.catalog,
      itemDetails = _useSelector3.itemDetails,
      isLoadingItemDetails = _useSelector3.isLoadingItemDetails,
      itemRecommendationData = _useSelector3.itemRecommendationData;

  var _useSelector4 = (0,es/* useSelector */.v9)(function (state) {
    return state.orderReducer;
  }),
      order = _useSelector4.order;

  var _useSelector5 = (0,es/* useSelector */.v9)(function (state) {
    return state.recommendationReducer;
  }),
      recommendations = _useSelector5.recommendations;

  var _useState = (0,react.useState)([]),
      promotions = _useState[0],
      setPromotions = _useState[1];

  var handleGetCatalogItens = function handleGetCatalogItens() {
    var refetch = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    if (establishment !== null && establishment !== void 0 && establishment.guid) {
      if (!catalog || refetch) {
        setFieldValue('isLoading', true);
        services_establishment/* establishmentService.getEstablishmentCatalog */.I.getEstablishmentCatalog(establishment.guid).then(function (v) {
          var updatedValues = v.map(function (category) {
            var updatedCategory = CatalogItens_objectSpread(CatalogItens_objectSpread({}, category), {}, {
              expanded: (establishment === null || establishment === void 0 ? void 0 : establishment.webSettings.itemDisplayModeInCategory) === lets_eat_types_esm/* ItemDisplayModeInCategory.open */.Ck.open
            });

            return updatedCategory;
          });
          setFieldValue('catalogItens', updatedValues);
          setFieldValue('isLoading', false);
          dispatch((0,catalog_reducer/* setCatalog */.fY)(updatedValues));
        });
      } else {
        setFieldValue('catalogItens', catalog);
      }
    }
  };

  var _handleSelectItem = function handleSelectItem(itemGuid, categoryType) {
    var _establishment$guid;

    dispatch((0,catalog_reducer/* setIsLoadingItemDetails */.UQ)(true));
    services_establishment/* establishmentService.getItemDetails */.I.getItemDetails((_establishment$guid = establishment === null || establishment === void 0 ? void 0 : establishment.guid) !== null && _establishment$guid !== void 0 ? _establishment$guid : '', itemGuid, categoryType).then(function (item) {
      dispatch((0,catalog_reducer/* setItemDetails */.rq)(item));

      if (!isXs) {
        push({
          pathname: "/item-details/".concat(itemGuid),
          query: {
            type: item.type
          }
        });
      }
    })["catch"]( /*#__PURE__*/(0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
      var _catalog$find, _order$items;

      var Swal, item, hasItemsInCart;
      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return Promise.resolve(/* import() */).then(__webpack_require__.t.bind(__webpack_require__, 86455, 23));

            case 2:
              Swal = _context.sent["default"];
              item = catalog === null || catalog === void 0 ? void 0 : (_catalog$find = catalog.find(function (category) {
                return category.items.some(function (item) {
                  return item.guid === itemGuid;
                });
              })) === null || _catalog$find === void 0 ? void 0 : _catalog$find.items.find(function (item) {
                return item.guid === itemGuid;
              });
              hasItemsInCart = order === null || order === void 0 ? void 0 : (_order$items = order.items) === null || _order$items === void 0 ? void 0 : _order$items.some(function (item) {
                return item.guid === itemGuid;
              });

              if (hasItemsInCart) {
                dispatch((0,order_reducer/* removeItemsByGuid */.HA)(itemGuid));
              }

              if (recommendations !== null && recommendations !== void 0 && recommendations.some(function (item) {
                return item.itemGuid === itemGuid;
              })) {
                dispatch((0,recommendation_reducer/* removeRecommendation */.Gj)(itemGuid));
              }

              handleGetCatalogItens(true);
              Swal.fire({
                title: 'Ops!',
                text: "O produto ".concat(item === null || item === void 0 ? void 0 : item.name, " n\xE3o est\xE1 dispon\xEDvel no momento").concat(hasItemsInCart ? ", as unidades em seu pedido foram REMOVIDAS" : '', "."),
                icon: 'error'
              });

            case 9:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    })))["finally"](function () {
      return dispatch((0,catalog_reducer/* setIsLoadingItemDetails */.UQ)(false));
    });
  };

  var handleShowRecommendation = function handleShowRecommendation(itemRecommendation) {
    dispatch((0,catalog_reducer/* setItemRecommendationData */.Ew)(itemRecommendation));
    dispatch((0,catalog_reducer/* setRecommendationGuid */.PO)(itemDetails === null || itemDetails === void 0 ? void 0 : itemDetails.guid));
  };

  var handleIWantClick = function handleIWantClick() {
    var _itemRecommendationDa;

    _handleSelectItem((_itemRecommendationDa = itemRecommendationData === null || itemRecommendationData === void 0 ? void 0 : itemRecommendationData.itemGuid) !== null && _itemRecommendationDa !== void 0 ? _itemRecommendationDa : '');

    dispatch((0,catalog_reducer/* setItemRecommendationData */.Ew)(undefined));
  };

  (0,react.useEffect)(handleGetCatalogItens, [establishment]);
  (0,react.useEffect)(function () {
    if (catalog && JSON.stringify(catalog) !== JSON.stringify(values.catalogItens)) {
      setFieldValue('catalogItens', catalog);
    }
  }, [catalog]);
  (0,react.useEffect)(function () {
    var discountItens = [];
    catalogItensFiltered.map(function (catalogItem) {
      if (catalogItem.isOnOpeningHours) {
        return catalogItem.items.map(function (item) {
          if (item.promotionPercentage) {
            var _catalogItem$guid;

            discountItens.push({
              product: item,
              catalogItemGuid: (_catalogItem$guid = catalogItem.guid) !== null && _catalogItem$guid !== void 0 ? _catalogItem$guid : '',
              catalogItemType: catalogItem.categoryType
            });
          }
        });
      }

      return;
    });
    setPromotions(discountItens);
  }, [catalogItensFiltered]); // eslint-disable-line

  (0,react.useEffect)(function () {
    if (!isXs && search) {
      modules/* scroller.scrollTo */.OK.scrollTo('catalog-items', {
        smooth: true
      });
    }
  }, [search]); // eslint-disable-line

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(components_ItemRecommendationDialog, {
      open: itemRecommendationData !== undefined,
      recommendedItem: itemRecommendationData,
      onIWantClick: handleIWantClick,
      onClose: function onClose() {
        dispatch((0,catalog_reducer/* setItemRecommendationData */.Ew)(undefined));
        dispatch((0,catalog_reducer/* removeRecommendationGuid */.Ag)());
      }
    }), itemDetails && isXs ? /*#__PURE__*/(0,jsx_runtime.jsx)(OrderItemDialog, {
      categoryGuid: itemDetails.categoryGuid,
      item: itemDetails,
      handleShowRecommendation: handleShowRecommendation,
      onClose: function onClose() {
        dispatch((0,catalog_reducer/* removeItemToEditInfo */.QH)());
        dispatch((0,catalog_reducer/* removeItemDetails */.Y9)());
      }
    }) : null, isLoadingItemDetails && /*#__PURE__*/(0,jsx_runtime.jsx)(BackdropProgressIndicator/* default */.Z, {}), /*#__PURE__*/(0,jsx_runtime.jsxs)(Box/* default */.Z, {
      className: classes.root,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(modules/* Element */.W_, {
        name: "catalog-items",
        children: isXs ? /*#__PURE__*/(0,jsx_runtime.jsx)(TransitionGroup/* default */.Z, {
          children: catalogItensFiltered.filter(function (i) {
            return i.items.length > 0;
          }).map(function (catalogItem) {
            return /*#__PURE__*/(0,jsx_runtime.jsx)(Collapse/* default */.Z, {
              className: classes.category,
              children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Box/* default */.Z, {
                children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(Box/* default */.Z, {
                  style: {
                    display: 'flex',
                    marginBottom: 8
                  },
                  children: [catalogItem.items.some(function (v) {
                    return v.promotionPercentage !== undefined;
                  }) && /*#__PURE__*/(0,jsx_runtime.jsx)(Box/* default */.Z, {
                    "data-testid": "category-promotion-indicator",
                    style: {
                      background: 'rgba(233, 245, 236, 0.75)',
                      padding: 4,
                      marginRight: 8,
                      borderRadius: 4,
                      maxHeight: 28
                    },
                    children: /*#__PURE__*/(0,jsx_runtime.jsx)(LocalOffer/* default */.Z, {
                      style: {
                        color: green/* default.600 */.Z[600],
                        fontSize: 20
                      }
                    })
                  }), /*#__PURE__*/(0,jsx_runtime.jsx)(Typography/* default */.Z, {
                    className: classes.title,
                    style: !catalogItem.isOnOpeningHours ? {
                      opacity: 0.5,
                      textDecoration: 'line-through'
                    } : undefined,
                    children: catalogItem.name
                  })]
                }), /*#__PURE__*/(0,jsx_runtime.jsx)(Typography/* default */.Z, {
                  className: classes.description,
                  style: !catalogItem.isOnOpeningHours ? {
                    opacity: 0.5,
                    textDecoration: 'line-through'
                  } : undefined,
                  children: catalogItem.description
                }), /*#__PURE__*/(0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                  container: true,
                  spacing: 4,
                  columns: 18,
                  children: catalogItem.items.map(function (item) {
                    var _catalogItem$guid2;

                    return /*#__PURE__*/(0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                      item: true,
                      sm: 9,
                      lg: 6,
                      children: /*#__PURE__*/(0,jsx_runtime.jsx)(components_CatalogIten, {
                        item: item,
                        isOnOpeningHours: catalogItem.isOnOpeningHours,
                        categoryGuid: (_catalogItem$guid2 = catalogItem.guid) !== null && _catalogItem$guid2 !== void 0 ? _catalogItem$guid2 : '',
                        handleSelectItem: function handleSelectItem(itemGuid) {
                          return _handleSelectItem(itemGuid, catalogItem.categoryType);
                        }
                      })
                    }, item.guid);
                  })
                })]
              })
            }, catalogItem.guid);
          })
        }) : /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
          children: [promotions.length > 0 && /*#__PURE__*/(0,jsx_runtime.jsx)(components_Promotions, {
            items: promotions,
            handleSelectItem: _handleSelectItem
          }), catalogItensFiltered.filter(function (i) {
            return i.items.length > 0;
          }).map(function (catalogItem) {
            return /*#__PURE__*/(0,jsx_runtime.jsx)(components_OrderCategoryAccordion, {
              category: catalogItem,
              handleSelectItem: _handleSelectItem
            }, catalogItem.guid);
          })]
        })
      }), values.isLoading ? /*#__PURE__*/(0,jsx_runtime.jsx)(components_SkeletonLoading, {
        isXs: isXs
      }) : /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: values.catalogItens.length === 0 && /*#__PURE__*/(0,jsx_runtime.jsx)(Stack/* default */.Z, {
          alignItems: "center",
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Stack/* default */.Z, {
            width: "100%",
            maxWidth: 280,
            gap: 3,
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(bored_cat/* default */.Z, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(Typography/* default */.Z, {
              style: {
                fontSize: '1.125rem',
                textAlign: 'center'
              },
              children: "Este estabelecimento n\xE3o possui itens dispon\xEDveis no momento"
            })]
          })
        })
      }), values.catalogItens.length !== 0 && catalogItensFiltered.every(function (i) {
        return i.items.length === 0;
      }) && /*#__PURE__*/(0,jsx_runtime.jsx)(NoItemsFound/* default */.Z, {
        text: "N\xE3o encontramos nenhum produto.",
        resetFilterValues: function resetFilterValues() {
          dispatch((0,search_reducer/* cleanSearch */.g0)());
        }
      })]
    })]
  });
};

/* harmony default export */ var CatalogItens_CatalogItens = (CatalogItens);
;// CONCATENATED MODULE: ./src/containers/IndexContainer/components/Catalog/components/CatalogItens/index.ts

/* harmony default export */ var components_CatalogItens = (CatalogItens_CatalogItens);
// EXTERNAL MODULE: ./node_modules/@mui/material/Tabs/Tabs.js + 8 modules
var Tabs = __webpack_require__(11703);
// EXTERNAL MODULE: ./node_modules/@mui/material/Tab/Tab.js + 1 modules
var Tab = __webpack_require__(40044);
// EXTERNAL MODULE: ./node_modules/@mui/material/Menu/Menu.js + 5 modules
var Menu = __webpack_require__(35294);
// EXTERNAL MODULE: ./node_modules/@mui/material/MenuItem/MenuItem.js + 3 modules
var MenuItem = __webpack_require__(23599);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/esm/KeyboardArrowDown.js
var KeyboardArrowDown = __webpack_require__(85578);
;// CONCATENATED MODULE: ./src/containers/IndexContainer/components/Catalog/components/Filters/Filters.tsx







var Filters_useStyles = (0,makeStyles/* default */.Z)(function () {
  return {
    paperRoot: {
      boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.14), 0px 4px 5px rgba(0, 0, 0, 0.12), 0px 1px 10px rgba(0, 0, 0, 0.2);'
    },
    root: {
      borderBottom: "2px solid ".concat(grey/* default.300 */.Z[300]),
      maxWidth: 150,
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis'
    }
  };
});

var Filters = function Filters(_ref) {
  var formik = _ref.formik;
  var classes = Filters_useStyles();

  var _useState = (0,react.useState)(null),
      anchorEl = _useState[0],
      setAnchorEl = _useState[1];

  var values = formik.values,
      setFieldValue = formik.setFieldValue;
  var arraySlice = [values.catalogItens.slice(0, 4), values.catalogItens.slice(4, values.catalogItens.length)];

  var handleClose = function handleClose() {
    setAnchorEl(null);
  };

  var handleOpen = function handleOpen(e) {
    setAnchorEl(e);
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
    item: true,
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(Tabs/* default */.Z, {
      value: values.filtersIndex > 4 ? 4 : values.filtersIndex,
      children: [arraySlice[0].map(function (item, i) {
        return /*#__PURE__*/(0,jsx_runtime.jsx)(Tooltip/* default */.Z, {
          title: item.name,
          arrow: true,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(Tab/* default */.Z, {
            onClick: function onClick() {
              return setFieldValue('filtersIndex', values.filtersIndex === i ? false : i);
            },
            label: item.name.length > 13 ? "".concat(item.name.substring(0, 10), "...") : item.name,
            className: classes.root
          })
        }, i);
      }), arraySlice[1].length > 0 && /*#__PURE__*/(0,jsx_runtime.jsx)(Tab/* default */.Z, {
        label: /*#__PURE__*/(0,jsx_runtime.jsxs)(Box/* default */.Z, {
          style: {
            alignItems: 'center',
            display: 'flex'
          },
          children: ["Mais", /*#__PURE__*/(0,jsx_runtime.jsx)(KeyboardArrowDown/* default */.Z, {})]
        }),
        onClick: function onClick(e) {
          return handleOpen(e.currentTarget);
        },
        className: classes.root
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Menu/* default */.Z, {
      anchorEl: anchorEl,
      open: !!anchorEl,
      onClose: handleClose,
      classes: {
        paper: classes.paperRoot
      },
      anchorOrigin: {
        vertical: 'bottom',
        horizontal: 'right'
      },
      transformOrigin: {
        vertical: 'top',
        horizontal: 'right'
      },
      children: arraySlice[1].map(function (item, i) {
        return /*#__PURE__*/(0,jsx_runtime.jsx)(MenuItem/* default */.Z, {
          onClick: function onClick() {
            setFieldValue('filtersIndex', values.filtersIndex === i + arraySlice[0].length ? false : i + arraySlice[0].length);
            handleClose();
          },
          children: item.name
        }, item.guid);
      })
    })]
  });
};

/* harmony default export */ var Filters_Filters = (Filters);
;// CONCATENATED MODULE: ./src/containers/IndexContainer/components/Catalog/components/Filters/index.ts

/* harmony default export */ var components_Filters = (Filters_Filters);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/esm/Search.js
var Search = __webpack_require__(96506);
// EXTERNAL MODULE: ./node_modules/@mui/material/utils/debounce.js
var debounce = __webpack_require__(57144);
// EXTERNAL MODULE: ./node_modules/@mui/material/TextField/TextField.js + 25 modules
var TextField = __webpack_require__(54052);
// EXTERNAL MODULE: ./node_modules/@mui/material/InputAdornment/InputAdornment.js + 1 modules
var InputAdornment = __webpack_require__(87109);
// EXTERNAL MODULE: ./node_modules/@mui/material/Fade/Fade.js
var Fade = __webpack_require__(16628);
;// CONCATENATED MODULE: ./src/containers/IndexContainer/components/Catalog/components/SearchBar/SearchBar.tsx









var SearchBar_useStyles = (0,makeStyles/* default */.Z)(function (theme) {
  return {
    root: {
      width: '100%',
      minWidth: 300
    },
    icons: {
      fontSize: 24,
      color: grey/* default.600 */.Z[600],
      cursor: 'pointer'
    }
  };
});

var SearchBar = function SearchBar() {
  var classes = SearchBar_useStyles();
  var dispatch = (0,es/* useDispatch */.I0)();

  var _useEventHandler = (0,hooks/* useEventHandler */.xd)(),
      eventHandler = _useEventHandler.eventHandler;

  var _useSelector = (0,es/* useSelector */.v9)(function (state) {
    return state.searchReducer;
  }),
      search = _useSelector.search;

  var searchTriggerDebounce = (0,react.useCallback)((0,debounce/* default */.Z)(function (search_term) {
    eventHandler.search(search_term);
  }, 1000), []);

  var handleSearchText = function handleSearchText(searchText) {
    dispatch((0,search_reducer/* setSearch */.qP)(searchText));
    searchTriggerDebounce(searchText);
  };

  var handleCleanSearch = function handleCleanSearch() {
    dispatch((0,search_reducer/* cleanSearch */.g0)());
  };

  return /*#__PURE__*/(0,jsx_runtime.jsx)(Grid/* default */.ZP, {
    item: true,
    style: {
      flex: 1,
      margin: 'auto'
    },
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(TextField/* default */.Z, {
      fullWidth: true,
      onChange: function onChange(e) {
        handleSearchText(e.target.value);
      },
      className: classes.root,
      value: search,
      size: "small",
      variant: "outlined",
      placeholder: "Pesquisar produtos",
      InputProps: {
        startAdornment: /*#__PURE__*/(0,jsx_runtime.jsx)(InputAdornment/* default */.Z, {
          position: "start",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(Search/* default */.Z, {
            className: classes.icons
          })
        }),
        endAdornment: /*#__PURE__*/(0,jsx_runtime.jsx)(InputAdornment/* default */.Z, {
          position: "end",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(Fade/* default */.Z, {
            "in": search.length > 0,
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(IconButton/* default */.Z, {
              className: classes.icons,
              onClick: handleCleanSearch,
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(Close/* default */.Z, {})
            })
          })
        })
      }
    })
  });
};

/* harmony default export */ var SearchBar_SearchBar = (SearchBar);
;// CONCATENATED MODULE: ./src/containers/IndexContainer/components/Catalog/components/SearchBar/index.ts

/* harmony default export */ var components_SearchBar = (SearchBar_SearchBar);
;// CONCATENATED MODULE: ./src/containers/IndexContainer/components/Catalog/Catalog.tsx


function Catalog_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function Catalog_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Catalog_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Catalog_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }












var Catalog_useStyles = (0,makeStyles/* default */.Z)(function (theme) {
  return {
    root: {
      marginBottom: 60,
      paddingTop: function paddingTop(_ref) {
        var filterHeight = _ref.filterHeight;
        return filterHeight;
      }
    },
    filter: {
      padding: '32px 0'
    },
    filterGrid: {
      display: 'flex',
      gap: 32,
      width: '100%',
      maxWidth: 1216,
      margin: '0 auto'
    }
  };
});
var initialValues = {
  filtersIndex: false,
  catalogItens: [],
  isLoading: false
};

var Catalog = function Catalog() {
  var _refBoxFilter$current;

  var refBoxFilter = (0,react.useRef)(null);
  var classes = Catalog_useStyles({
    filterHeight: (_refBoxFilter$current = refBoxFilter.current) === null || _refBoxFilter$current === void 0 ? void 0 : _refBoxFilter$current.clientHeight
  });

  var _useSelector = (0,es/* useSelector */.v9)(function (state) {
    return state.searchReducer;
  }),
      search = _useSelector.search;

  var formik = (0,formik_esm/* useFormik */.TA)({
    initialValues: initialValues,
    onSubmit: function onSubmit(values) {}
  });
  var values = formik.values;
  var catalogItensFiltered = (0,react.useMemo)(function () {
    var newValues = values.catalogItens.map(function (v) {
      return Catalog_objectSpread(Catalog_objectSpread({}, v), {}, {
        items: (0,scoredSearch/* default */.Z)({
          originalArr: v.items.map(function (item) {
            return Catalog_objectSpread(Catalog_objectSpread({}, item), {}, {
              catalogName: v.name,
              catalogDescription: v.description
            });
          }),
          strSearch: search.toLowerCase(),
          fieldSearch: ['name', 'description', 'catalogName', 'catalogDescription', 'searchTags']
        })
      });
    });
    return values.filtersIndex !== false ? [newValues[values.filtersIndex]] : newValues;
  }, [search, values.catalogItens, values.filtersIndex]);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(Box/* default */.Z, {
    className: classes.root,
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Hidden/* default */.Z, {
      smDown: true,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(Box/* default */.Z, {
        className: classes.filter,
        ref: refBoxFilter,
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
          container: true,
          className: classes.filterGrid,
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(components_SearchBar, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(components_Filters, {
            formik: formik
          })]
        })
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(components_CatalogItens, {
      formik: formik,
      catalogItensFiltered: catalogItensFiltered
    })]
  });
};

/* harmony default export */ var Catalog_Catalog = (Catalog);
;// CONCATENATED MODULE: ./src/containers/IndexContainer/components/Catalog/index.ts

/* harmony default export */ var components_Catalog = (Catalog_Catalog);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/esm/InfoOutlined.js
var InfoOutlined = __webpack_require__(36804);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/esm/Room.js
var Room = __webpack_require__(93752);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/esm/SportsMotorsports.js
var SportsMotorsports = __webpack_require__(11829);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/esm/LocalMall.js
var LocalMall = __webpack_require__(40488);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/esm/ShoppingCart.js
var ShoppingCart = __webpack_require__(90422);
// EXTERNAL MODULE: ./public/svg/CouponIcon.tsx
var CouponIcon = __webpack_require__(16833);
// EXTERNAL MODULE: ./src/helpers/utils/getUnityOfTime.ts
var getUnityOfTime = __webpack_require__(83619);
// EXTERNAL MODULE: ./src/helpers/utils/numberFormat.ts
var numberFormat = __webpack_require__(20715);
// EXTERNAL MODULE: ./src/shared/models/index.ts + 10 modules
var models = __webpack_require__(86596);
// EXTERNAL MODULE: ./src/shared/models/loyaltyPlan.ts
var models_loyaltyPlan = __webpack_require__(59344);
// EXTERNAL MODULE: ./src/containers/LoyaltyContainer/components/LoyaltyCard/components/LoyaltyInformation/index.ts + 5 modules
var LoyaltyInformation = __webpack_require__(84698);
// EXTERNAL MODULE: ./src/containers/LoyaltyContainer/components/LoyaltyInfoDialog/index.ts + 1 modules
var LoyaltyInfoDialog = __webpack_require__(31331);
;// CONCATENATED MODULE: ./src/containers/IndexContainer/components/EstablishmentBasicInfoSection/components/BasicInfoItem/BasicInfoItem.tsx







var BasicInfoItem_useStyles = (0,makeStyles/* default */.Z)(function (theme) {
  return {
    root: (0,defineProperty/* default */.Z)({
      gap: 8,
      color: '#808080'
    }, theme.breakpoints.down('md'), {
      flexDirection: 'column'
    }),
    textContainer: (0,defineProperty/* default */.Z)({}, theme.breakpoints.down('md'), {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center'
    }),
    text: (0,defineProperty/* default */.Z)({}, theme.breakpoints.down('md'), {
      fontSize: '.875rem',
      textAlign: 'center'
    })
  };
});

var BasicInfoItem = function BasicInfoItem(_ref) {
  var isLoading = _ref.isLoading,
      icon = _ref.icon,
      primaryText = _ref.primaryText,
      secondaryText = _ref.secondaryText,
      style = _ref.style;
  var classes = BasicInfoItem_useStyles();
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(Box/* default */.Z, {
    style: style,
    display: "flex",
    alignItems: "center",
    className: classes.root,
    children: [isLoading ? /*#__PURE__*/(0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
      variant: "circular",
      width: 24,
      height: 24
    }) : icon, /*#__PURE__*/(0,jsx_runtime.jsx)(Box/* default */.Z, {
      className: classes.textContainer,
      children: isLoading ? /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
          variant: "text",
          width: 85
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
          variant: "text",
          width: 105
        })]
      }) : /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Typography/* default */.Z, {
          className: classes.text,
          style: {
            lineHeight: 1.25
          },
          children: primaryText
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Typography/* default */.Z, {
          className: classes.text,
          children: secondaryText
        })]
      })
    })]
  });
};

/* harmony default export */ var BasicInfoItem_BasicInfoItem = (BasicInfoItem);
;// CONCATENATED MODULE: ./src/containers/IndexContainer/components/EstablishmentBasicInfoSection/components/BasicInfoItem/index.ts

/* harmony default export */ var components_BasicInfoItem = (BasicInfoItem_BasicInfoItem);
// EXTERNAL MODULE: ./node_modules/@mui/material/Avatar/Avatar.js + 2 modules
var Avatar = __webpack_require__(69661);
// EXTERNAL MODULE: ./public/svg/WhiteLogoAvatar.tsx
var WhiteLogoAvatar = __webpack_require__(43912);
;// CONCATENATED MODULE: ./src/containers/IndexContainer/components/EstablishmentBasicInfoSection/components/EstablishmentAvatar/EstablishmentAvatar.tsx





var EstablishmentAvatar_useStyles = (0,makeStyles/* default */.Z)(function (theme) {
  return {
    root: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: 80,
      height: 80,
      borderRadius: '50%',
      backgroundColor: theme.palette.primary.main
    }
  };
});

var EstablishmentAvatar = function EstablishmentAvatar(_ref) {
  var establishmentName = _ref.establishmentName,
      path = _ref.path;
  var classes = EstablishmentAvatar_useStyles();

  if (!path) {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(Box/* default */.Z, {
      className: classes.root,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(WhiteLogoAvatar/* default */.Z, {
        viewBox: "0 0 47 35",
        style: {
          width: 47,
          height: 35
        }
      })
    });
  }

  return /*#__PURE__*/(0,jsx_runtime.jsx)(Avatar/* default */.Z, {
    variant: "circular",
    src: path,
    alt: establishmentName,
    style: {
      width: 80,
      height: 80
    }
  });
};

/* harmony default export */ var EstablishmentAvatar_EstablishmentAvatar = (EstablishmentAvatar);
;// CONCATENATED MODULE: ./src/containers/IndexContainer/components/EstablishmentBasicInfoSection/components/EstablishmentAvatar/index.ts

/* harmony default export */ var components_EstablishmentAvatar = (EstablishmentAvatar_EstablishmentAvatar);
// EXTERNAL MODULE: ./node_modules/@mui/material/Drawer/Drawer.js + 1 modules
var Drawer = __webpack_require__(58826);
// EXTERNAL MODULE: ./src/shared/components/TabPanel/index.ts + 1 modules
var TabPanel = __webpack_require__(42744);
;// CONCATENATED MODULE: ./src/containers/IndexContainer/components/EstablishmentBasicInfoSection/components/EstablishmentInfoDrawer/components/AboutTab/AboutTab.tsx









var AboutTab_useStyles = (0,makeStyles/* default */.Z)(function (theme) {
  return {
    title: {
      fontWeight: 600,
      marginBottom: 10
    }
  };
});

var AboutTab = function AboutTab() {
  var _establishment$delive, _establishment$delive2, _establishment$delive3, _establishment$delive4, _establishment$delive5;

  var classes = AboutTab_useStyles();

  var _useSelector = (0,es/* useSelector */.v9)(function (state) {
    return state.establishmentReducer;
  }),
      establishment = _useSelector.establishment;

  var address = establishment === null || establishment === void 0 ? void 0 : establishment.baseInfo.address;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
    container: true,
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
      item: true,
      xs: 12,
      style: {
        marginBottom: 32
      },
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Typography/* default */.Z, {
        className: classes.title,
        children: establishment === null || establishment === void 0 ? void 0 : establishment.name
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Box/* default */.Z, {
        display: "flex",
        alignItems: "center",
        style: {
          color: '#808080',
          gap: 8
        },
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Room/* default */.Z, {}), /*#__PURE__*/(0,jsx_runtime.jsxs)(Box/* default */.Z, {
          "data-testid": "establishment-address-container",
          children: [(establishment === null || establishment === void 0 ? void 0 : establishment.settings.showAddress) && /*#__PURE__*/(0,jsx_runtime.jsx)(Typography/* default */.Z, {
            children: "Rua ".concat(address === null || address === void 0 ? void 0 : address.street, ", ").concat(address === null || address === void 0 ? void 0 : address.number, " ").concat(address !== null && address !== void 0 && address.complement ? "- ".concat(address.complement) : '')
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(Typography/* default */.Z, {
            children: "".concat(address === null || address === void 0 ? void 0 : address.neighborhood, ", ").concat(address === null || address === void 0 ? void 0 : address.city.name, " - ").concat(address === null || address === void 0 ? void 0 : address.city.state.uf)
          })]
        })]
      })]
    }), (establishment === null || establishment === void 0 ? void 0 : establishment.baseInfo.about) && /*#__PURE__*/(0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
      item: true,
      xs: 12,
      style: {
        marginBottom: 32
      },
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Typography/* default */.Z, {
        className: classes.title,
        children: "Sobre"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Typography/* default */.Z, {
        style: {
          color: '#808080'
        },
        children: establishment === null || establishment === void 0 ? void 0 : establishment.baseInfo.about
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
      item: true,
      xs: 12,
      style: {
        marginBottom: 32
      },
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Typography/* default */.Z, {
        className: classes.title,
        children: "Formas de entrega"
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Box/* default */.Z, {
        display: "flex",
        alignItems: "center",
        flexWrap: "wrap",
        justifyContent: "space-between",
        style: {
          gap: 16
        },
        children: [(establishment === null || establishment === void 0 ? void 0 : (_establishment$delive = establishment.deliverySettings) === null || _establishment$delive === void 0 ? void 0 : _establishment$delive.enableTakeOut) && /*#__PURE__*/(0,jsx_runtime.jsxs)(Box/* default */.Z, {
          display: "flex",
          alignItems: "center",
          style: {
            color: '#333',
            gap: 8
          },
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(LocalMall/* default */.Z, {}), /*#__PURE__*/(0,jsx_runtime.jsxs)(Box/* default */.Z, {
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Typography/* default */.Z, {
              style: {
                fontWeight: 600
              },
              children: "Retirada"
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(Typography/* default */.Z, {
              style: {
                color: '#808080',
                fontSize: '.875rem',
                fontWeight: 400
              },
              children: "Retirar produtos no estabelecimento"
            })]
          })]
        }), (establishment === null || establishment === void 0 ? void 0 : (_establishment$delive2 = establishment.deliverySettings) === null || _establishment$delive2 === void 0 ? void 0 : _establishment$delive2.enableDelivery) && /*#__PURE__*/(0,jsx_runtime.jsxs)(Box/* default */.Z, {
          display: "flex",
          alignItems: "center",
          style: {
            color: '#333',
            gap: 8
          },
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(SportsMotorsports/* default */.Z, {}), /*#__PURE__*/(0,jsx_runtime.jsxs)(Box/* default */.Z, {
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Typography/* default */.Z, {
              style: {
                fontWeight: 600
              },
              children: "Delivery"
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(Typography/* default */.Z, {
              style: {
                color: '#808080',
                fontSize: '.875rem',
                fontWeight: 400
              },
              children: "Entrega no endere\xE7o informado"
            })]
          })]
        })]
      })]
    }), (establishment === null || establishment === void 0 ? void 0 : (_establishment$delive3 = establishment.deliverySettings) === null || _establishment$delive3 === void 0 ? void 0 : _establishment$delive3.deliveryFeeType) === models.DeliveryFeeType.neighborhoodFee && /*#__PURE__*/(0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
      item: true,
      xs: 12,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Typography/* default */.Z, {
        className: classes.title,
        children: "Entregas e valores"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Grid/* default */.ZP, {
        container: true,
        style: {
          gap: 16,
          marginTop: 16
        },
        children: establishment === null || establishment === void 0 ? void 0 : (_establishment$delive4 = establishment.deliverySettings) === null || _establishment$delive4 === void 0 ? void 0 : (_establishment$delive5 = _establishment$delive4.neighborhoodFees) === null || _establishment$delive5 === void 0 ? void 0 : _establishment$delive5.map(function (fee, index) {
          return /*#__PURE__*/(0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
            item: true,
            xs: 12,
            display: "flex",
            flexDirection: "column",
            style: {
              gap: 8
            },
            children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(Box/* default */.Z, {
              display: "flex",
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Room/* default */.Z, {
                style: {
                  color: '#636965',
                  marginRight: 8
                }
              }), /*#__PURE__*/(0,jsx_runtime.jsx)(Typography/* default */.Z, {
                style: {
                  color: '#636965',
                  fontWeight: 600
                },
                children: fee.city.name
              })]
            }), fee.neighborhoodFees.map(function (neighborhoodFee) {
              return /*#__PURE__*/(0,jsx_runtime.jsxs)(Box/* default */.Z, {
                display: "flex",
                justifyContent: "space-between",
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Typography/* default */.Z, {
                  style: {
                    color: '#636965',
                    fontWeight: 400
                  },
                  children: neighborhoodFee.neighborhood
                }), /*#__PURE__*/(0,jsx_runtime.jsx)(Typography/* default */.Z, {
                  style: {
                    color: '#636965',
                    fontWeight: 400
                  },
                  children: (0,utils/* toCurrencyValue */.y6)(neighborhoodFee.fee)
                })]
              }, neighborhoodFee.guid);
            })]
          }, "".concat(fee.city.name, "-").concat(index));
        })
      })]
    })]
  });
};

/* harmony default export */ var AboutTab_AboutTab = (AboutTab);
;// CONCATENATED MODULE: ./src/containers/IndexContainer/components/EstablishmentBasicInfoSection/components/EstablishmentInfoDrawer/components/AboutTab/index.ts

/* harmony default export */ var components_AboutTab = (AboutTab_AboutTab);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/esm/AccessAlarm.js
var AccessAlarm = __webpack_require__(63976);
;// CONCATENATED MODULE: ./src/containers/IndexContainer/components/EstablishmentBasicInfoSection/components/EstablishmentInfoDrawer/components/OpeningHoursTab/OpeningHoursTab.tsx










var OpeningHoursTab_useStyles = (0,makeStyles/* default */.Z)(function (theme) {
  return {
    hourContainer: {
      '& + &': {
        marginTop: 24
      }
    },
    bold: {
      '& .MuiTypography-root': {
        fontWeight: 700
      }
    }
  };
});

var OpeningHoursTab = function OpeningHoursTab() {
  var classes = OpeningHoursTab_useStyles();

  var _useTimeZone = (0,hooks/* useTimeZone */.a4)(),
      correctCurrentTime = _useTimeZone.correctCurrentTime;

  var _useSelector = (0,es/* useSelector */.v9)(function (state) {
    return state.openingHoursSettingsReducer;
  }),
      openingHoursSettings = _useSelector.openingHoursSettings;

  var days = [{
    translated: 'Segunda-feira',
    dayOfWeek: models.DayOfTheWeek.monday
  }, {
    translated: 'Terça-feira',
    dayOfWeek: models.DayOfTheWeek.tuesday
  }, {
    translated: 'Quarta-feira',
    dayOfWeek: models.DayOfTheWeek.wednesday
  }, {
    translated: 'Quinta-feira',
    dayOfWeek: models.DayOfTheWeek.thursday
  }, {
    translated: 'Sexta-feira',
    dayOfWeek: models.DayOfTheWeek.friday
  }, {
    translated: 'Sábado',
    dayOfWeek: models.DayOfTheWeek.saturday
  }, {
    translated: 'Domingo',
    dayOfWeek: models.DayOfTheWeek.sunday
  }];
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Grid/* default */.ZP, {
    container: true,
    children: days.map(function (day) {
      var isToday = correctCurrentTime().format('dddd') === day.translated.toLowerCase();
      return /*#__PURE__*/(0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
        item: true,
        "data-testid": "".concat(day.dayOfWeek, "-container"),
        xs: 12,
        display: "flex",
        justifyContent: "space-between",
        className: classes.hourContainer,
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(Box/* default */.Z, {
          display: "flex",
          className: isToday ? classes.bold : undefined,
          style: {
            gap: 8
          },
          children: [isToday && /*#__PURE__*/(0,jsx_runtime.jsx)(AccessAlarm/* default */.Z, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(Typography/* default */.Z, {
            children: day.translated
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Box/* default */.Z, {
          display: "flex",
          flexWrap: "wrap",
          justifyContent: "end",
          className: isToday ? classes.bold : undefined,
          style: {
            gap: 8,
            maxWidth: '75%'
          },
          children: (0,utils/* getOpeningHours */.JZ)(day.dayOfWeek, openingHoursSettings === null || openingHoursSettings === void 0 ? void 0 : openingHoursSettings.openingHours)
        })]
      }, day.translated);
    })
  });
};

/* harmony default export */ var OpeningHoursTab_OpeningHoursTab = (OpeningHoursTab);
;// CONCATENATED MODULE: ./src/containers/IndexContainer/components/EstablishmentBasicInfoSection/components/EstablishmentInfoDrawer/components/OpeningHoursTab/index.ts

/* harmony default export */ var components_OpeningHoursTab = (OpeningHoursTab_OpeningHoursTab);
;// CONCATENATED MODULE: ./src/containers/IndexContainer/components/EstablishmentBasicInfoSection/components/EstablishmentInfoDrawer/components/PaymentInfoTab/components/PaymentCard/PaymentCard.tsx





var PaymentCard_useStyles = (0,makeStyles/* default */.Z)(function (theme) {
  return {
    root: {
      display: 'flex',
      alignItems: 'center',
      gap: 8,
      padding: '10px 8px',
      border: 'none',
      backgroundColor: '#efefef'
    }
  };
});

var PaymentCard = function PaymentCard(_ref) {
  var icon = _ref.icon,
      label = _ref.label;
  var classes = PaymentCard_useStyles();
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(Card/* default */.Z, {
    variant: "outlined",
    className: classes.root,
    children: [typeof icon === 'string' ? /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
      height: 24,
      src: icon,
      alt: label
    }) : icon, /*#__PURE__*/(0,jsx_runtime.jsx)(Typography/* default */.Z, {
      style: {
        color: '#666'
      },
      children: label
    })]
  });
};

/* harmony default export */ var PaymentCard_PaymentCard = (PaymentCard);
;// CONCATENATED MODULE: ./src/containers/IndexContainer/components/EstablishmentBasicInfoSection/components/EstablishmentInfoDrawer/components/PaymentInfoTab/components/PaymentCard/index.ts

/* harmony default export */ var components_PaymentCard = (PaymentCard_PaymentCard);
;// CONCATENATED MODULE: ./src/containers/IndexContainer/components/EstablishmentBasicInfoSection/components/EstablishmentInfoDrawer/components/PaymentInfoTab/components/PaymentMethodSection/PaymentMethodSection.tsx








var PaymentMethodSection = function PaymentMethodSection(_ref) {
  var paymentType = _ref.paymentType,
      flags = _ref.flags;

  var _getPaymentTypeProps = (0,utils/* getPaymentTypeProps */.vd)(paymentType, '#666'),
      name = _getPaymentTypeProps.name,
      icon = _getPaymentTypeProps.icon;

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(Box/* default */.Z, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Typography/* default */.Z, {
      style: {
        fontWeight: 700
      },
      children: name
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Box/* default */.Z, {
      mt: 2,
      display: "flex",
      flexWrap: "wrap",
      style: {
        gap: 16
      },
      children: flags && flags.length > 0 ? /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: flags.map(function (flag) {
          var _getCardFlags$icon;

          return /*#__PURE__*/(0,jsx_runtime.jsx)(components_PaymentCard, {
            icon: (_getCardFlags$icon = (0,utils/* getCardFlags */.FK)(flag.name).icon) !== null && _getCardFlags$icon !== void 0 ? _getCardFlags$icon : '',
            label: flag.name
          }, flag.guid);
        })
      }) : /*#__PURE__*/(0,jsx_runtime.jsx)(components_PaymentCard, {
        icon: icon,
        label: name
      })
    })]
  });
};

/* harmony default export */ var PaymentMethodSection_PaymentMethodSection = (PaymentMethodSection);
;// CONCATENATED MODULE: ./src/containers/IndexContainer/components/EstablishmentBasicInfoSection/components/EstablishmentInfoDrawer/components/PaymentInfoTab/components/PaymentMethodSection/index.ts

/* harmony default export */ var components_PaymentMethodSection = (PaymentMethodSection_PaymentMethodSection);
;// CONCATENATED MODULE: ./src/containers/IndexContainer/components/EstablishmentBasicInfoSection/components/EstablishmentInfoDrawer/components/PaymentInfoTab/PaymentInfoTab.tsx








var PaymentInfoTab_useStyles = (0,makeStyles/* default */.Z)(function (theme) {
  return {
    sectionContainer: {
      '& + &': {
        marginTop: 24
      }
    }
  };
});

var PaymentInfoTab = function PaymentInfoTab() {
  var classes = PaymentInfoTab_useStyles();

  var _useSelector = (0,es/* useSelector */.v9)(function (state) {
    return state.establishmentReducer;
  }),
      establishment = _useSelector.establishment;

  var acceptCash = establishment === null || establishment === void 0 ? void 0 : establishment.paymentSettings.acceptCash;
  var acceptCredit = establishment === null || establishment === void 0 ? void 0 : establishment.paymentSettings.acceptCredit;
  var acceptDebit = establishment === null || establishment === void 0 ? void 0 : establishment.paymentSettings.acceptDebit;
  var acceptPix = establishment === null || establishment === void 0 ? void 0 : establishment.paymentSettings.acceptPix;
  var acceptVoucher = establishment === null || establishment === void 0 ? void 0 : establishment.paymentSettings.acceptVoucher;
  var acceptMercadoPago = establishment === null || establishment === void 0 ? void 0 : establishment.paymentSettings.acceptMercadoPago;
  var creditCardFlags = establishment === null || establishment === void 0 ? void 0 : establishment.paymentSettings.creditCardFlags;
  var debitCardFlags = establishment === null || establishment === void 0 ? void 0 : establishment.paymentSettings.debitCardFlags;
  var voucherCardFlags = establishment === null || establishment === void 0 ? void 0 : establishment.paymentSettings.voucherCardFlags;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
    "data-testid": "payment-info-container",
    container: true,
    children: [acceptCash && /*#__PURE__*/(0,jsx_runtime.jsx)(Grid/* default */.ZP, {
      item: true,
      xs: 12,
      className: classes.sectionContainer,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(components_PaymentMethodSection, {
        paymentType: models.PaymentType.cash
      })
    }), acceptCredit && /*#__PURE__*/(0,jsx_runtime.jsx)(Grid/* default */.ZP, {
      item: true,
      xs: 12,
      className: classes.sectionContainer,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(components_PaymentMethodSection, {
        paymentType: models.PaymentType.credit,
        flags: creditCardFlags
      })
    }), acceptDebit && /*#__PURE__*/(0,jsx_runtime.jsx)(Grid/* default */.ZP, {
      item: true,
      xs: 12,
      className: classes.sectionContainer,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(components_PaymentMethodSection, {
        paymentType: models.PaymentType.debit,
        flags: debitCardFlags
      })
    }), acceptPix && /*#__PURE__*/(0,jsx_runtime.jsx)(Grid/* default */.ZP, {
      item: true,
      xs: 12,
      className: classes.sectionContainer,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(components_PaymentMethodSection, {
        paymentType: models.PaymentType.pix
      })
    }), acceptVoucher && /*#__PURE__*/(0,jsx_runtime.jsx)(Grid/* default */.ZP, {
      item: true,
      xs: 12,
      className: classes.sectionContainer,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(components_PaymentMethodSection, {
        paymentType: models.PaymentType.voucher,
        flags: voucherCardFlags
      })
    }), acceptMercadoPago && /*#__PURE__*/(0,jsx_runtime.jsx)(Grid/* default */.ZP, {
      item: true,
      xs: 12,
      className: classes.sectionContainer,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(components_PaymentMethodSection, {
        paymentType: models.PaymentType.mercadoPago
      })
    })]
  });
};

/* harmony default export */ var PaymentInfoTab_PaymentInfoTab = (PaymentInfoTab);
;// CONCATENATED MODULE: ./src/containers/IndexContainer/components/EstablishmentBasicInfoSection/components/EstablishmentInfoDrawer/components/PaymentInfoTab/index.ts

/* harmony default export */ var components_PaymentInfoTab = (PaymentInfoTab_PaymentInfoTab);
;// CONCATENATED MODULE: ./src/containers/IndexContainer/components/EstablishmentBasicInfoSection/components/EstablishmentInfoDrawer/EstablishmentInfoDrawer.tsx











var EstablishmentInfoDrawer_useStyles = (0,makeStyles/* default */.Z)(function (theme) {
  var _paper;

  return {
    paper: (_paper = {
      width: 658,
      maxWidth: '100%',
      height: 600,
      left: 'calc(50% - 329px)',
      paddingBottom: 32
    }, (0,defineProperty/* default */.Z)(_paper, theme.breakpoints.down('md'), {
      height: 'calc(100% - 64px)',
      width: '100%',
      left: 'calc(50% - 50vw)',
      borderRadius: '8px 8px 0 0'
    }), (0,defineProperty/* default */.Z)(_paper, theme.breakpoints.down('sm'), {
      paddingBottom: 0
    }), _paper)
  };
});

var EstablishmentInfoDrawer = function EstablishmentInfoDrawer(_ref) {
  var open = _ref.open,
      onClose = _ref.onClose;
  var classes = EstablishmentInfoDrawer_useStyles();
  var theme = (0,useTheme/* default */.Z)();
  var isXs = (0,useMediaQuery/* default */.Z)(theme.breakpoints.down('sm'));

  var _useState = (0,react.useState)(0),
      currentTab = _useState[0],
      setCurrentTab = _useState[1];

  var handleChangeTab = function handleChangeTab(event, tab) {
    setCurrentTab(tab);
  };

  var handleChangeIndex = function handleChangeIndex(index) {
    setCurrentTab(index);
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(Drawer/* default */.ZP, {
    open: open,
    anchor: "bottom",
    onBackdropClick: onClose,
    onClose: onClose,
    PaperProps: {
      className: classes.paper
    },
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(Box/* default */.Z, {
      display: "flex",
      justifyContent: "space-between",
      style: {
        padding: !isXs ? '32px 32px 0 32px' : '16px 16px 0 16px'
      },
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(Tabs/* default */.Z, {
        value: currentTab,
        onChange: handleChangeTab,
        indicatorColor: "primary",
        textColor: "primary",
        variant: "scrollable",
        scrollButtons: "auto",
        style: {
          width: 'min-content',
          borderBottom: '1px solid #ccc'
        },
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Tab/* default */.Z, {
          label: "sobre"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Tab/* default */.Z, {
          label: "hor\xE1rio"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Tab/* default */.Z, {
          label: "pagamento"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Tooltip/* default */.Z, {
        title: "Fechar",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(IconButton/* default */.Z, {
          "data-testid": "close-drawer-btn",
          style: {
            width: 49
          },
          onClick: onClose,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(Close/* default */.Z, {})
        })
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Box/* default */.Z, {
      style: {
        padding: !isXs ? '0 32px' : '0 16px 16px 32px',
        overflow: 'auto'
      },
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(TabPanel/* default */.Z, {
        value: currentTab,
        index: 0,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(components_AboutTab, {})
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(TabPanel/* default */.Z, {
        value: currentTab,
        index: 1,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(components_OpeningHoursTab, {})
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(TabPanel/* default */.Z, {
        value: currentTab,
        index: 2,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(components_PaymentInfoTab, {})
      })]
    })]
  });
};

/* harmony default export */ var EstablishmentInfoDrawer_EstablishmentInfoDrawer = (EstablishmentInfoDrawer);
;// CONCATENATED MODULE: ./src/containers/IndexContainer/components/EstablishmentBasicInfoSection/components/EstablishmentInfoDrawer/index.ts

/* harmony default export */ var components_EstablishmentInfoDrawer = (EstablishmentInfoDrawer_EstablishmentInfoDrawer);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/esm/CalendarMonth.js
var CalendarMonth = __webpack_require__(63252);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/esm/AlarmOff.js
var AlarmOff = __webpack_require__(40820);
// EXTERNAL MODULE: ./node_modules/@mui/material/colors/red.js
var red = __webpack_require__(60265);
;// CONCATENATED MODULE: ./src/containers/IndexContainer/components/EstablishmentBasicInfoSection/components/OpenCloseIndicator/OpenCloseIndicator.tsx











var OpenCloseIndicator_useStyles = (0,makeStyles/* default */.Z)(function (theme) {
  return {
    root: (0,defineProperty/* default */.Z)({
      gap: 8,
      color: '#808080'
    }, theme.breakpoints.down('md'), {
      flexDirection: 'column'
    }),
    textContainer: (0,defineProperty/* default */.Z)({}, theme.breakpoints.down('md'), {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center'
    }),
    text: (0,defineProperty/* default */.Z)({}, theme.breakpoints.down('md'), {
      fontSize: '.875rem',
      textAlign: 'center'
    })
  };
});

var OpenCloseIndicator = function OpenCloseIndicator() {
  var classes = OpenCloseIndicator_useStyles();

  var _useSelector = (0,es/* useSelector */.v9)(function (state) {
    return state.openingHoursSettingsReducer;
  }),
      openingHoursSettings = _useSelector.openingHoursSettings;

  var showOpenInfo = (openingHoursSettings === null || openingHoursSettings === void 0 ? void 0 : openingHoursSettings.isOpen) && ((openingHoursSettings === null || openingHoursSettings === void 0 ? void 0 : openingHoursSettings.openType) === models.OpenType.open || (openingHoursSettings === null || openingHoursSettings === void 0 ? void 0 : openingHoursSettings.openType) === models.OpenType.openWithSchedule);
  var showOnlyScheduleInfo = (openingHoursSettings === null || openingHoursSettings === void 0 ? void 0 : openingHoursSettings.isOpen) && (openingHoursSettings === null || openingHoursSettings === void 0 ? void 0 : openingHoursSettings.openType) === models.OpenType.onlySchedule || !(openingHoursSettings !== null && openingHoursSettings !== void 0 && openingHoursSettings.isOpen) && (openingHoursSettings === null || openingHoursSettings === void 0 ? void 0 : openingHoursSettings.openType) === models.OpenType.closedWithSchedule;
  var showClosedInfo = !(openingHoursSettings !== null && openingHoursSettings !== void 0 && openingHoursSettings.isOpen) && (openingHoursSettings === null || openingHoursSettings === void 0 ? void 0 : openingHoursSettings.openType) === models.OpenType.closed;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(Box/* default */.Z, {
    style: {
      color: showOpenInfo ? green/* default.500 */.Z[500] : showOnlyScheduleInfo ? '#E08600' : red/* default.500 */.Z[500]
    },
    display: "flex",
    alignItems: "center",
    className: classes.root,
    children: [!openingHoursSettings ? /*#__PURE__*/(0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
      variant: "circular",
      width: 24,
      height: 24
    }) : /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
      children: [showOpenInfo && /*#__PURE__*/(0,jsx_runtime.jsx)(AccessAlarm/* default */.Z, {}), showOnlyScheduleInfo && /*#__PURE__*/(0,jsx_runtime.jsx)(CalendarMonth/* default */.Z, {}), showClosedInfo && /*#__PURE__*/(0,jsx_runtime.jsx)(AlarmOff/* default */.Z, {})]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Box/* default */.Z, {
      className: classes.textContainer,
      children: !openingHoursSettings ? /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Box/* default */.Z, {
          "data-testid": "loading-container",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
            variant: "text",
            width: 85
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
            variant: "text",
            width: 105
          })]
        })
      }) : /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(Typography/* default */.Z, {
          className: classes.text,
          style: {
            lineHeight: 1.25
          },
          children: [showOpenInfo && 'Aberto', showOnlyScheduleInfo && 'Aberto para', showClosedInfo && 'Fechado']
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Typography/* default */.Z, {
          className: classes.text,
          children: [(showOpenInfo || showClosedInfo) && 'para pedidos', showOnlyScheduleInfo && 'agendamentos']
        })]
      })
    })]
  });
};

/* harmony default export */ var OpenCloseIndicator_OpenCloseIndicator = (OpenCloseIndicator);
;// CONCATENATED MODULE: ./src/containers/IndexContainer/components/EstablishmentBasicInfoSection/components/OpenCloseIndicator/index.ts

/* harmony default export */ var components_OpenCloseIndicator = (OpenCloseIndicator_OpenCloseIndicator);
;// CONCATENATED MODULE: ./src/containers/IndexContainer/components/EstablishmentBasicInfoSection/EstablishmentBasicInfoSection.tsx





















var EstablishmentBasicInfoSection_useStyles = (0,makeStyles/* default */.Z)(function (theme) {
  return {
    root: (0,defineProperty/* default */.Z)({
      rowGap: '1rem',
      marginTop: 32,
      paddingBottom: 32,
      borderBottom: "1px solid ".concat(theme.palette.divider)
    }, theme.breakpoints.down('md'), {
      marginTop: 64,
      borderBottom: "2px solid ".concat(theme.palette.divider)
    }),
    basicInfoItemGrid: (0,defineProperty/* default */.Z)({
      gap: 24
    }, theme.breakpoints.down('md'), {
      gap: 16,
      flexDirection: 'column',
      marginBottom: 28,
      flexBasis: '100%'
    }),
    couponItemGrid: (0,defineProperty/* default */.Z)({}, theme.breakpoints.down('lg'), {
      flexBasis: '100%',
      marginTop: 28
    }),
    infoButtonMobile: {
      textTransform: 'none',
      flexDirection: 'column',
      '& .MuiButton-startIcon': {
        marginRight: 0
      }
    }
  };
});

var EstablishmentBasicInfoSection = function EstablishmentBasicInfoSection() {
  var _establishment$backgr, _establishment$name, _establishment$name2, _establishment$delive, _establishment$delive2, _establishment$delive3, _establishment$delive4, _establishment$delive5, _establishment$delive6, _establishment$delive7, _establishment$delive8, _establishment$delive9, _establishment$delive10, _establishment$delive11, _establishment$delive12, _establishment$delive13, _establishment$delive14, _establishment$delive15, _establishment$delive16, _establishment$delive17, _establishment$delive18;

  var classes = EstablishmentBasicInfoSection_useStyles();
  var theme = (0,useTheme/* default */.Z)();
  var isMobile = (0,useMediaQuery/* default */.Z)(theme.breakpoints.down('md'));

  var _useSelector = (0,es/* useSelector */.v9)(function (state) {
    return state.establishmentReducer;
  }),
      establishment = _useSelector.establishment;

  var _useSelector2 = (0,es/* useSelector */.v9)(function (state) {
    return state.orderReducer.order;
  }),
      orderCoupon = _useSelector2.orderCoupon;

  var _useSelector3 = (0,es/* useSelector */.v9)(function (state) {
    return state.loyaltyPlanReducer;
  }),
      isLoading = _useSelector3.isLoading,
      loyaltyPlan = _useSelector3.loyaltyPlan,
      myLoyaltyPlanState = _useSelector3.myLoyaltyPlanState;

  var establishmentAddress = establishment === null || establishment === void 0 ? void 0 : establishment.baseInfo.address;

  var _useState = (0,react.useState)(false),
      showEstablishmentInfoDrawer = _useState[0],
      setShowEstablishmentInfoDrawer = _useState[1];

  var _useState2 = (0,react.useState)(false),
      loyaltyCardInfoDialog = _useState2[0],
      setLoyaltyCardInfoDialog = _useState2[1];

  var couponText = (0,react.useMemo)(function () {
    var _orderCoupon$discount;

    if (!orderCoupon) return '';
    var isPercentage = orderCoupon.discountValueType === models.DiscountValueType.percentage;
    var isFeeDiscount = orderCoupon.discountTarget === lets_eat_types_esm/* DiscountTarget.deliveryFee */.fR.deliveryFee;
    var text = 'Desconto de ';
    text += isPercentage ? "".concat(orderCoupon.discount, "%") : (0,numberFormat/* toCurrencyValue */.y)((_orderCoupon$discount = orderCoupon.discount) !== null && _orderCoupon$discount !== void 0 ? _orderCoupon$discount : 0);
    text += ' no ';
    text += isFeeDiscount ? 'frete' : 'pedido';

    if (orderCoupon.minimumOrderValue) {
      text += " para pedido <b>m\xEDnimo de ".concat((0,numberFormat/* toCurrencyValue */.y)(orderCoupon.minimumOrderValue), "</b>");
    }

    return text;
  }, [orderCoupon]);

  var handleOpenEstablishmentInfoDrawer = function handleOpenEstablishmentInfoDrawer() {
    setShowEstablishmentInfoDrawer(true);
  };

  var handleCloseEstablishmentInfoDrawer = function handleCloseEstablishmentInfoDrawer() {
    setShowEstablishmentInfoDrawer(false);
  };

  var handleOpenLoyaltyCardInfoDialog = function handleOpenLoyaltyCardInfoDialog() {
    setLoyaltyCardInfoDialog(true);
  };

  var handleCloseLoyaltyCardInfoDialog = function handleCloseLoyaltyCardInfoDialog() {
    setLoyaltyCardInfoDialog(false);
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [loyaltyCardInfoDialog && loyaltyPlan && !isMobile && /*#__PURE__*/(0,jsx_runtime.jsx)(LoyaltyInfoDialog/* default */.Z, {
      open: true,
      data: loyaltyPlan,
      onClose: handleCloseLoyaltyCardInfoDialog
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(components_EstablishmentInfoDrawer, {
      open: showEstablishmentInfoDrawer,
      onClose: handleCloseEstablishmentInfoDrawer
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Box/* default */.Z, {
      height: isMobile && !(establishment !== null && establishment !== void 0 && establishment.backgroundPath) ? 75 : undefined,
      style: {
        position: 'relative'
      },
      children: [(establishment === null || establishment === void 0 ? void 0 : establishment.backgroundPath) &&
      /*#__PURE__*/
      // eslint-disable-next-line @next/next/no-img-element
      (0,jsx_runtime.jsx)("img", {
        height: !isMobile ? 192 : 120,
        width: "100%",
        src: (_establishment$backgr = establishment === null || establishment === void 0 ? void 0 : establishment.backgroundPath) !== null && _establishment$backgr !== void 0 ? _establishment$backgr : '',
        alt: "Capa do estabelecimento",
        style: {
          objectFit: 'cover'
        }
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Hidden/* default */.Z, {
        mdUp: true,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(Box/* default */.Z, {
          style: {
            position: 'absolute',
            left: 'calc(50% - 40px)',
            bottom: -40
          },
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(components_EstablishmentAvatar, {
            establishmentName: (_establishment$name = establishment === null || establishment === void 0 ? void 0 : establishment.name) !== null && _establishment$name !== void 0 ? _establishment$name : '',
            path: establishment === null || establishment === void 0 ? void 0 : establishment.thumbLogoPath
          })
        })
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
      container: true,
      alignItems: !isMobile ? 'center' : 'flex-start',
      justifyContent: !isMobile ? 'space-between' : 'space-evenly',
      className: classes.root,
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
        item: true,
        className: classes.basicInfoItemGrid,
        display: "flex",
        alignItems: "center",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Hidden/* default */.Z, {
          mdDown: true,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(components_EstablishmentAvatar, {
            establishmentName: (_establishment$name2 = establishment === null || establishment === void 0 ? void 0 : establishment.name) !== null && _establishment$name2 !== void 0 ? _establishment$name2 : '',
            path: establishment === null || establishment === void 0 ? void 0 : establishment.thumbLogoPath
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Box/* default */.Z, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(Box/* default */.Z, {
            display: "flex",
            alignItems: "center",
            justifyContent: isMobile ? 'center' : 'space-between',
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Typography/* default */.Z, {
              variant: "h5",
              style: {
                fontWeight: 600
              },
              children: establishment === null || establishment === void 0 ? void 0 : establishment.name
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(Hidden/* default */.Z, {
              mdDown: true,
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(Button/* default */.Z, {
                "data-testid": "info-button",
                color: "primary",
                startIcon: /*#__PURE__*/(0,jsx_runtime.jsx)(InfoOutlined/* default */.Z, {}),
                style: {
                  textTransform: 'none',
                  marginLeft: 8
                },
                onClick: handleOpenEstablishmentInfoDrawer,
                children: "Informa\xE7\xF5es"
              })
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Box/* default */.Z, {
            display: "flex",
            alignItems: "center",
            style: {
              gap: 8,
              color: '#808080',
              marginTop: 10
            },
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Room/* default */.Z, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(Typography/* default */.Z, {
              style: {
                fontSize: isMobile ? '.875rem' : undefined
              },
              children: "".concat(establishmentAddress === null || establishmentAddress === void 0 ? void 0 : establishmentAddress.neighborhood, ", ").concat(establishmentAddress === null || establishmentAddress === void 0 ? void 0 : establishmentAddress.city.name, " - ").concat(establishmentAddress === null || establishmentAddress === void 0 ? void 0 : establishmentAddress.city.state.uf)
            })]
          })]
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Grid/* default */.ZP, {
        item: true,
        children: establishment !== null && establishment !== void 0 && (_establishment$delive = establishment.deliverySettings) !== null && _establishment$delive !== void 0 && _establishment$delive.enableDelivery ? /*#__PURE__*/(0,jsx_runtime.jsx)(components_BasicInfoItem, {
          icon: /*#__PURE__*/(0,jsx_runtime.jsx)(SportsMotorsports/* default */.Z, {}),
          primaryText: "".concat((_establishment$delive2 = establishment === null || establishment === void 0 ? void 0 : (_establishment$delive3 = establishment.deliverySettings.deliveryAverageTime) === null || _establishment$delive3 === void 0 ? void 0 : _establishment$delive3.from) !== null && _establishment$delive2 !== void 0 ? _establishment$delive2 : 0, " - ").concat((_establishment$delive4 = establishment === null || establishment === void 0 ? void 0 : (_establishment$delive5 = establishment.deliverySettings.deliveryAverageTime) === null || _establishment$delive5 === void 0 ? void 0 : _establishment$delive5.until) !== null && _establishment$delive4 !== void 0 ? _establishment$delive4 : 0),
          secondaryText: (0,getUnityOfTime/* getUnityOfTime */.s)((_establishment$delive6 = establishment === null || establishment === void 0 ? void 0 : (_establishment$delive7 = establishment.deliverySettings.deliveryAverageTime) === null || _establishment$delive7 === void 0 ? void 0 : _establishment$delive7.unityOfTime) !== null && _establishment$delive6 !== void 0 ? _establishment$delive6 : '')
        }) : /*#__PURE__*/(0,jsx_runtime.jsx)(components_BasicInfoItem, {
          icon: /*#__PURE__*/(0,jsx_runtime.jsx)(LocalMall/* default */.Z, {}),
          primaryText: "".concat((_establishment$delive8 = establishment === null || establishment === void 0 ? void 0 : (_establishment$delive9 = establishment.deliverySettings) === null || _establishment$delive9 === void 0 ? void 0 : (_establishment$delive10 = _establishment$delive9.takeOutAverageTime) === null || _establishment$delive10 === void 0 ? void 0 : _establishment$delive10.from) !== null && _establishment$delive8 !== void 0 ? _establishment$delive8 : 0, " - ").concat((_establishment$delive11 = establishment === null || establishment === void 0 ? void 0 : (_establishment$delive12 = establishment.deliverySettings) === null || _establishment$delive12 === void 0 ? void 0 : (_establishment$delive13 = _establishment$delive12.takeOutAverageTime) === null || _establishment$delive13 === void 0 ? void 0 : _establishment$delive13.until) !== null && _establishment$delive11 !== void 0 ? _establishment$delive11 : 0),
          secondaryText: (0,getUnityOfTime/* getUnityOfTime */.s)((_establishment$delive14 = establishment === null || establishment === void 0 ? void 0 : (_establishment$delive15 = establishment.deliverySettings) === null || _establishment$delive15 === void 0 ? void 0 : (_establishment$delive16 = _establishment$delive15.takeOutAverageTime) === null || _establishment$delive16 === void 0 ? void 0 : _establishment$delive16.unityOfTime) !== null && _establishment$delive14 !== void 0 ? _establishment$delive14 : '')
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Grid/* default */.ZP, {
        item: true,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(components_OpenCloseIndicator, {})
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Grid/* default */.ZP, {
        item: true,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(components_BasicInfoItem, {
          icon: /*#__PURE__*/(0,jsx_runtime.jsx)(ShoppingCart/* default */.Z, {}),
          primaryText: "Pedido m\xEDnimo",
          secondaryText: (0,numberFormat/* toCurrencyValue */.y)((_establishment$delive17 = establishment === null || establishment === void 0 ? void 0 : (_establishment$delive18 = establishment.deliverySettings) === null || _establishment$delive18 === void 0 ? void 0 : _establishment$delive18.minDeliveryAmount) !== null && _establishment$delive17 !== void 0 ? _establishment$delive17 : 0),
          style: {
            width: isMobile ? 'min-content' : undefined
          }
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Hidden/* default */.Z, {
        mdDown: true,
        children: (loyaltyPlan === null || loyaltyPlan === void 0 ? void 0 : loyaltyPlan.status) === models_loyaltyPlan/* LoyaltyPlanStatus.activated */.I.activated || isLoading ? /*#__PURE__*/(0,jsx_runtime.jsx)(Grid/* default */.ZP, {
          item: true,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(LoyaltyInformation/* default */.Z, {
            data: loyaltyPlan,
            currentPoints: myLoyaltyPlanState === null || myLoyaltyPlanState === void 0 ? void 0 : myLoyaltyPlanState.currentPoints,
            singleComponentVariant: true,
            onClick: handleOpenLoyaltyCardInfoDialog,
            isLoading: isLoading
          })
        }) : /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {})
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Hidden/* default */.Z, {
        mdUp: true,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(Grid/* default */.ZP, {
          item: true,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(Button/* default */.Z, {
            color: "primary",
            className: classes.infoButtonMobile,
            startIcon: /*#__PURE__*/(0,jsx_runtime.jsx)(InfoOutlined/* default */.Z, {}),
            onClick: handleOpenEstablishmentInfoDrawer,
            children: "Info"
          })
        })
      }), orderCoupon && /*#__PURE__*/(0,jsx_runtime.jsx)(Grid/* default */.ZP, {
        item: true,
        display: "flex",
        justifyContent: "center",
        className: classes.couponItemGrid,
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Box/* default */.Z, {
          style: {
            maxWidth: 320,
            background: '#ECF6F0',
            padding: '4px 8px',
            display: 'flex',
            alignItems: 'center',
            borderRadius: 4
          },
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(CouponIcon/* default */.Z, {
            style: {
              color: '#3DA865'
            }
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(Box/* default */.Z, {
            style: {
              marginLeft: 8
            },
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(Typography/* default */.Z, {
              style: {
                color: '#3DA865'
              },
              dangerouslySetInnerHTML: {
                __html: couponText
              }
            })
          })]
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Hidden/* default */.Z, {
        mdUp: true,
        children: ((loyaltyPlan === null || loyaltyPlan === void 0 ? void 0 : loyaltyPlan.status) === models_loyaltyPlan/* LoyaltyPlanStatus.activated */.I.activated || isLoading) && /*#__PURE__*/(0,jsx_runtime.jsx)(Box/* default */.Z, {
          display: "flex",
          justifyContent: 'center',
          width: "100%",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(LoyaltyInformation/* default */.Z, {
            data: loyaltyPlan,
            currentPoints: myLoyaltyPlanState === null || myLoyaltyPlanState === void 0 ? void 0 : myLoyaltyPlanState.currentPoints,
            singleComponentVariant: true,
            onClick: handleOpenLoyaltyCardInfoDialog,
            isLoading: isLoading
          })
        })
      })]
    })]
  });
};

/* harmony default export */ var EstablishmentBasicInfoSection_EstablishmentBasicInfoSection = (EstablishmentBasicInfoSection);
;// CONCATENATED MODULE: ./src/containers/IndexContainer/components/EstablishmentBasicInfoSection/index.ts

/* harmony default export */ var components_EstablishmentBasicInfoSection = (EstablishmentBasicInfoSection_EstablishmentBasicInfoSection);
// EXTERNAL MODULE: ./node_modules/@mui/material/ButtonBase/ButtonBase.js + 4 modules
var ButtonBase = __webpack_require__(49990);
// EXTERNAL MODULE: ./node_modules/@mui/material/Badge/Badge.js + 3 modules
var Badge = __webpack_require__(46724);
// EXTERNAL MODULE: ./src/redux/reducers/order/selectors.ts + 3 modules
var selectors = __webpack_require__(48104);
;// CONCATENATED MODULE: ./src/containers/IndexContainer/components/MobileCartButton/MobileCartButton.tsx










var MobileCartButton_useStyles = (0,makeStyles/* default */.Z)(function (theme) {
  return {
    root: {
      backgroundColor: theme.palette.primary.main,
      minHeight: 60,
      position: 'fixed',
      left: 0,
      bottom: 56,
      width: '100vw',
      zIndex: 2,
      borderRadius: 0
    },
    content: {
      padding: 16,
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      height: 60
    },
    icon: {
      color: theme.palette.primary.contrastText,
      fontSize: 24,
      marginRight: 8
    },
    text: {
      textTransform: 'uppercase',
      color: theme.palette.primary.contrastText,
      fontSize: '1rem',
      fontWeight: 500
    },
    chip: {
      backgroundColor: 'white',
      fontWeight: 600,
      fontSize: '.875rem'
    }
  };
});

var MobileCartButton = function MobileCartButton() {
  var _orderCheckout$items$, _orderCheckout$items, _orderCheckout$items$2, _orderCheckout$items2, _orderCheckout$items$3, _orderCheckout$items3;

  var classes = MobileCartButton_useStyles();

  var _useRouter = (0,router.useRouter)(),
      push = _useRouter.push;

  var orderCheckout = (0,es/* useSelector */.v9)(function (state) {
    return state.orderReducer.order;
  });
  var total = (0,es/* useSelector */.v9)(selectors/* itemsTotalSelector */.AA);

  if (orderCheckout === undefined || ((_orderCheckout$items$ = (_orderCheckout$items = orderCheckout.items) === null || _orderCheckout$items === void 0 ? void 0 : _orderCheckout$items.length) !== null && _orderCheckout$items$ !== void 0 ? _orderCheckout$items$ : 0) === 0) {
    return null;
  }

  return /*#__PURE__*/(0,jsx_runtime.jsx)(Paper/* default */.Z, {
    className: classes.root,
    elevation: 0,
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(ButtonBase/* default */.Z, {
      "data-testid": "mobile-cart-button",
      style: {
        width: '100%',
        display: 'contents'
      },
      onClick: function onClick() {
        return push('/cart');
      },
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(Grow/* default */.Z, {
        "in": true,
        timeout: 500,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: classes.content,
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Badge/* default */.Z, {
              badgeContent: (_orderCheckout$items$2 = (_orderCheckout$items2 = orderCheckout.items) === null || _orderCheckout$items2 === void 0 ? void 0 : _orderCheckout$items2.length) !== null && _orderCheckout$items$2 !== void 0 ? _orderCheckout$items$2 : 0,
              color: "secondary",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(ShoppingCart/* default */.Z, {
                className: classes.icon
              })
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(Typography/* default */.Z, {
              className: classes.text,
              children: "ver carrinho (".concat((_orderCheckout$items$3 = (_orderCheckout$items3 = orderCheckout.items) === null || _orderCheckout$items3 === void 0 ? void 0 : _orderCheckout$items3.length) !== null && _orderCheckout$items$3 !== void 0 ? _orderCheckout$items$3 : 0, ")")
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(Typography/* default */.Z, {
              className: classes.text,
              children: (0,utils/* toCurrencyValue */.y6)(total !== null && total !== void 0 ? total : 0)
            })]
          })
        })
      })
    })
  });
};

/* harmony default export */ var MobileCartButton_MobileCartButton = (MobileCartButton);
;// CONCATENATED MODULE: ./src/containers/IndexContainer/components/MobileCartButton/index.ts

/* harmony default export */ var components_MobileCartButton = (MobileCartButton_MobileCartButton);
;// CONCATENATED MODULE: ./src/containers/IndexContainer/IndexContainer.tsx




function IndexContainer_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function IndexContainer_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? IndexContainer_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : IndexContainer_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }































var IndexContainer_useStyles = (0,makeStyles/* default */.Z)(function (theme) {
  return {
    root: (0,defineProperty/* default */.Z)({
      minHeight: 'calc(100vh - 129px)',
      width: '100%',
      display: 'flex',
      justifyContent: 'center'
    }, theme.breakpoints.down('sm'), {
      minHeight: 'calc(100vh - 184px)'
    }),
    container: {
      maxWidth: 1216,
      width: 1216
    }
  };
});

var Home = function Home(_ref) {
  var establishmentData = _ref.establishmentData,
      disc = _ref.disc;
  var classes = IndexContainer_useStyles();
  var dispatch = (0,es/* useDispatch */.I0)();
  var theme = (0,useTheme/* default */.Z)();

  var _useRouter = (0,router.useRouter)(),
      query = _useRouter.query,
      replace = _useRouter.replace,
      pathname = _useRouter.pathname;

  var _useCouponWithRequire = (0,couponWithRequiredAuth/* useCouponWithRequiredAuthStore */.n)(),
      handleOpenCouponWithRequiredAuth = _useCouponWithRequire.onOpen,
      handleCloseCouponWithRequiredAuth = _useCouponWithRequire.onClose,
      showCouponWithRequiredAuth = _useCouponWithRequire.isOpen,
      onCloseAllCallback = _useCouponWithRequire.onCloseAllCallback;

  var _useReadOnly = (0,readOnly/* useReadOnly */.G)(),
      setReadOnly = _useReadOnly.setReadOnly,
      isReadOnly = _useReadOnly.isReadOnly;

  var isMobile = (0,useMediaQuery/* default */.Z)(theme.breakpoints.down('sm'));

  var _useSelector = (0,es/* useSelector */.v9)(function (state) {
    return state.establishmentReducer;
  }),
      establishment = _useSelector.establishment;

  var _useSelector2 = (0,es/* useSelector */.v9)(function (state) {
    return state.searchReducer;
  }),
      search = _useSelector2.search;

  var _useSelector3 = (0,es/* useSelector */.v9)(function (state) {
    return state.userDiscountReducer;
  }),
      discountCode = _useSelector3.discountCode;

  var _useSelector4 = (0,es/* useSelector */.v9)(function (state) {
    return state.discountCodeReducer;
  }),
      couponAwaitingAuth = _useSelector4.couponAwaitingAuth;

  var _useSelector5 = (0,es/* useSelector */.v9)(function (state) {
    return state.publicUserReducer;
  }),
      user = _useSelector5.user;

  var _useSelector6 = (0,es/* useSelector */.v9)(function (state) {
    return state.orderReducer;
  }),
      newItemAdded = _useSelector6.newItemAdded,
      order = _useSelector6.order,
      orderMetadata = _useSelector6.orderMetadata;

  var _useSelector7 = (0,es/* useSelector */.v9)(function (state) {
    return state.userInfoReducer;
  }),
      userInfo = _useSelector7.userInfo;

  var _useSelector8 = (0,es/* useSelector */.v9)(function (state) {
    return state.sessionReducer;
  }),
      session = _useSelector8.session;

  var _useState = (0,react.useState)(false),
      showCartWithItemsSpeechBubble = _useState[0],
      setShowCartWithItemsSpeechBubble = _useState[1];

  var _useState2 = (0,react.useState)({
    isOpen: false,
    isError: false
  }),
      showCouponAlert = _useState2[0],
      setShowCouponAlert = _useState2[1];

  var handleOpenCouponErrorAlert = function handleOpenCouponErrorAlert() {
    setShowCouponAlert({
      isOpen: true,
      isError: true
    });
  };

  var handleOpenCouponAlert = function handleOpenCouponAlert() {
    setShowCouponAlert({
      isOpen: true,
      isError: false
    });
  };

  var handleCloseCouponAlert = function handleCloseCouponAlert() {
    setShowCouponAlert({
      isOpen: false,
      isError: false
    });
    dispatch((0,reducer/* setCouponAwaitingAuth */.UK)(undefined));
  };

  var getCoupon = function getCoupon(code) {
    var _ref2, _establishmentData$gu;

    var establishmentGuid = (_ref2 = (_establishmentData$gu = establishmentData === null || establishmentData === void 0 ? void 0 : establishmentData.guid) !== null && _establishmentData$gu !== void 0 ? _establishmentData$gu : establishment === null || establishment === void 0 ? void 0 : establishment.guid) !== null && _ref2 !== void 0 ? _ref2 : '';
    dispatch((0,actions/* getDiscountCodeByCode */.h)({
      Code: code,
      establishmentGuid: establishmentGuid,
      hideErrorMessage: true
    })).then(redux_toolkit_esm/* unwrapResult */.SI).then(function (coupon) {
      if (coupon.couponNotFound) {
        handleOpenCouponErrorAlert();
        return;
      }

      dispatch((0,order_reducer/* setDiscountCode */.lA)(coupon));
      handleOpenCouponAlert();
    })["finally"](function () {
      window.isFetching = false;
    });
  };

  window.onbeforeunload = function () {
    var _order$items$length, _order$items;

    if (((_order$items$length = (_order$items = order.items) === null || _order$items === void 0 ? void 0 : _order$items.length) !== null && _order$items$length !== void 0 ? _order$items$length : 0) > 0) {
      return 'Are you sure you want to leave?';
    }
  };

  (0,react.useEffect)(function () {
    if (establishmentData) dispatch((0,establishment_reducer/* setEstablishmentData */.kO)(establishmentData));

    var metadataQuery = IndexContainer_objectSpread({}, query);

    if (query && !(orderMetadata !== null && orderMetadata !== void 0 && orderMetadata.query)) {
      dispatch((0,order_reducer/* setOrderMetadata */.HR)({
        query: metadataQuery
      }));
    }

    if (user && couponAwaitingAuth) {
      if (window.isSecondLoad) {
        getCoupon(couponAwaitingAuth);
      } else {
        window.isSecondLoad = true;
      }
    }

    setReadOnly(query.readOnly === 'true');
  }, []); // eslint-disable-line

  (0,react.useEffect)(function () {
    if (!disc || window.isCouponValidated) return;
    window.isCouponValidated = true;

    if (disc.error) {
      if (disc.errorName === 'DiscountCodeNeedsPublicUserException') {
        if (user && disc.couponCode) {
          getCoupon(disc.couponCode);
          return;
        }

        dispatch((0,reducer/* setCouponAwaitingAuth */.UK)(disc.couponCode));
        handleOpenCouponWithRequiredAuth();
        return;
      }

      react_toastify_esm/* toast.error */.Am.error(disc.error);
    } else if (disc.Coupon) {
      dispatch((0,order_reducer/* setDiscountCode */.lA)(disc.Coupon));
      handleOpenCouponAlert();
    }
  }, [disc]);
  (0,react.useEffect)(function () {
    var accessToken = authService/* authService.getAccessToken */.O.getAccessToken();

    if (establishmentData && !discountCode && accessToken) {
      dispatch((0,userDiscountCode_actions/* getDiscountCode */.$)({
        establishmentGuid: establishmentData.guid,
        pageIndex: 1
      }));
    }
  }, [establishmentData]);
  (0,react.useEffect)(function () {
    if (!establishment) return;

    var handleCreateNewSession = /*#__PURE__*/function () {
      var _ref3 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
        var newSession;
        return regenerator_default().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (userInfo) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt("return");

              case 2:
                _context.next = 4;
                return publicSession/* publicSessionService.create */.X.create(establishment.guid, userInfo.whatsApp);

              case 4:
                newSession = _context.sent;
                dispatch((0,session_reducer/* setSession */.KY)(newSession));
                dispatch((0,order_reducer/* setOrderTrackingDetails */.B)({
                  publicUserSession: newSession.guid
                }));

              case 7:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function handleCreateNewSession() {
        return _ref3.apply(this, arguments);
      };
    }();

    (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee2() {
      var res, url, stringified;
      return regenerator_default().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (!(!query.ccs && !session && userInfo)) {
                _context2.next = 4;
                break;
              }

              _context2.next = 3;
              return handleCreateNewSession();

            case 3:
              return _context2.abrupt("return");

            case 4:
              if (!(query.ccs && (!session || session.guid.replace(/\W/g, '') !== query.ccs))) {
                _context2.next = 30;
                break;
              }

              _context2.prev = 5;
              _context2.next = 8;
              return publicSession/* publicSessionService.get */.X.get(establishment.guid, query.ccs);

            case 8:
              res = _context2.sent;

              if (!(user && userInfo !== null && userInfo !== void 0 && userInfo.whatsApp)) {
                _context2.next = 17;
                break;
              }

              if (!(userInfo.whatsApp === res.contactInformation)) {
                _context2.next = 14;
                break;
              }

              dispatch((0,session_reducer/* setSession */.KY)(res));
              dispatch((0,order_reducer/* setOrderTrackingDetails */.B)({
                publicUserSession: res.guid
              }));
              return _context2.abrupt("return");

            case 14:
              _context2.next = 16;
              return handleCreateNewSession();

            case 16:
              return _context2.abrupt("return");

            case 17:
              dispatch((0,order_reducer/* setOrderTrackingDetails */.B)({
                publicUserSession: res.guid
              }));
              dispatch((0,session_reducer/* setSession */.KY)(res));
              dispatch((0,userInfo_reducer/* setUserInfo */.ps)({
                whatsApp: res.contactInformation
              }));
              _context2.next = 30;
              break;

            case 22:
              _context2.prev = 22;
              _context2.t0 = _context2["catch"](5);
              _context2.next = 26;
              return handleCreateNewSession();

            case 26:
              url = query;
              delete url.ccs;
              stringified = "?".concat(query_string.stringify(url));
              replace("/".concat(stringified), undefined, {
                shallow: true
              });

            case 30:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[5, 22]]);
    }))();
  }, [establishment]); // eslint-disable-line

  (0,react.useEffect)(function () {
    if (!showCartWithItemsSpeechBubble && newItemAdded) {
      setShowCartWithItemsSpeechBubble(true);
    }

    var timer = setTimeout(function () {
      setShowCartWithItemsSpeechBubble(false);
      dispatch((0,order_reducer/* OrderCheckoutResetNewItemAddedIndicator */.N5)());
    }, 1000 * 3);
    return function () {
      return clearTimeout(timer);
    };
  }, [newItemAdded]); // eslint-disable-line

  if (establishment) {
    return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)((head_default()), {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("title", {
          children: "".concat(establishment === null || establishment === void 0 ? void 0 : establishment.name, " - Card\xE1pio e Delivery")
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(components_CouponWithRequiredAuthAlert, {
        open: showCouponWithRequiredAuth,
        onClose: handleCloseCouponWithRequiredAuth,
        closeAll: function closeAll() {
          handleCloseCouponWithRequiredAuth();
          onCloseAllCallback === null || onCloseAllCallback === void 0 ? void 0 : onCloseAllCallback();
        }
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(AvailableCouponDialogAlert/* default */.Z, {
        dialogId: "cart-coupon-dialog-cart"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(components_CouponAlert, {
        open: showCouponAlert.isOpen,
        onClose: handleCloseCouponAlert,
        isError: showCouponAlert.isError
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(components_CartWithItemsSpeechBubble, {
        show: showCartWithItemsSpeechBubble
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Box/* default */.Z, {
        className: classes.root,
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Box/* default */.Z, {
          className: classes.container,
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Collapse/* default */.Z, {
            "in": !isMobile || isMobile && !search,
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(components_EstablishmentBasicInfoSection, {})
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(components_Catalog, {})]
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Hidden/* default */.Z, {
        smUp: true,
        children: !isReadOnly && /*#__PURE__*/(0,jsx_runtime.jsx)(components_MobileCartButton, {})
      })]
    });
  }

  return /*#__PURE__*/(0,jsx_runtime.jsx)("h1", {
    children: "sem loja"
  });
};

/* harmony default export */ var IndexContainer = (Home);
;// CONCATENATED MODULE: ./src/pages/index.tsx

/* harmony default export */ var pages = (IndexContainer);

/***/ }),

/***/ 42744:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_TabPanel; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(4730);
// EXTERNAL MODULE: ./node_modules/@mui/system/esm/Box/Box.js
var Box = __webpack_require__(18377);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/shared/components/TabPanel/TabPanel.tsx


var _excluded = ["children", "value", "index", "disableDefaultMargin"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }






var TabPanel = function TabPanel(_ref) {
  var children = _ref.children,
      value = _ref.value,
      index = _ref.index,
      _ref$disableDefaultMa = _ref.disableDefaultMargin,
      disableDefaultMargin = _ref$disableDefaultMa === void 0 ? false : _ref$disableDefaultMa,
      other = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);

  return /*#__PURE__*/(0,jsx_runtime.jsx)(Box/* default */.Z, _objectSpread(_objectSpread({
    mt: !disableDefaultMargin ? 4 : undefined,
    role: "tabpanel",
    hidden: value !== index
  }, other), {}, {
    children: value === index && /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
      children: children
    })
  }));
};

/* harmony default export */ var TabPanel_TabPanel = (TabPanel);
;// CONCATENATED MODULE: ./src/shared/components/TabPanel/index.ts

/* harmony default export */ var components_TabPanel = (TabPanel_TabPanel);

/***/ }),

/***/ 83033:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "X": function() { return /* binding */ publicSessionService; }
/* harmony export */ });
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(50029);
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(87794);
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _api__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(31033);



var baseUrl = '/api/public/sessions';

function create(_x, _x2) {
  return _create.apply(this, arguments);
}

function _create() {
  _create = (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)( /*#__PURE__*/_app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(establishmentGuid, contactInformation) {
    return _app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            return _context.abrupt("return", _api__WEBPACK_IMPORTED_MODULE_1__/* ["default"].post */ .Z.post("".concat(baseUrl, "/").concat(establishmentGuid, "/create"), {
              contactInformation: contactInformation
            }, {
              headers: {
                'x-api-version': '3'
              }
            }).then(function (response) {
              return response.data;
            }));

          case 1:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _create.apply(this, arguments);
}

function update(_x3, _x4) {
  return _update.apply(this, arguments);
}

function _update() {
  _update = (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)( /*#__PURE__*/_app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee2(establishmentGuid, data) {
    return _app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            return _context2.abrupt("return", _api__WEBPACK_IMPORTED_MODULE_1__/* ["default"].put */ .Z.put("".concat(baseUrl, "/").concat(establishmentGuid, "/update"), data, {
              headers: {
                'x-api-version': '3'
              }
            }).then(function (response) {
              return response.data;
            }));

          case 1:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _update.apply(this, arguments);
}

function get(_x5, _x6) {
  return _get.apply(this, arguments);
}

function _get() {
  _get = (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)( /*#__PURE__*/_app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee3(establishmentGuid, sessionGuid) {
    return _app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            return _context3.abrupt("return", _api__WEBPACK_IMPORTED_MODULE_1__/* ["default"].get */ .Z.get("".concat(baseUrl, "/").concat(establishmentGuid, "/session/").concat(sessionGuid.replace('-', '')), {
              headers: {
                hideErrorMessage: 'true',
                'x-api-version': '3'
              }
            }).then(function (response) {
              return response.data;
            }));

          case 1:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
  return _get.apply(this, arguments);
}

var publicSessionService = {
  create: create,
  update: update,
  get: get
};

/***/ }),

/***/ 48312:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(73968);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [976,433,428,549,43,194,101,774,888,179], function() { return __webpack_exec__(48312); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);